import React, { useState, useEffect, useRef } from "react";
import {
  Button, Dialog, DialogTitle,
  DialogContent, DialogActions, Box, Typography, IconButton,
  Snackbar, Alert, Chip, Tooltip
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SelectField from "../../components/ui/basicSelectInput";
import { ValidatorForm } from "react-material-ui-form-validator";
import { Grid } from "@material-ui/core";
import axios from "../../axios-order";
import classes from "./Reporting.module.css";
import ValidatedDatePicker from "../../components/ui/monthWiseDatePicker";
import DownloadIcon from "@mui/icons-material/Download";
import RefreshIcon from "@mui/icons-material/Refresh";
import BoxWrapper from "../../components/ui/boxWrapper";
import "../../HOC/layout/layout.css";
import VisibilityIcon from "@material-ui/icons/Visibility";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import BusinessIcon from '@mui/icons-material/Business';
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Close as CloseIcon } from '@mui/icons-material';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import RightDrawer from "../../components/ui/RightDrawer";
import Inputfield from "../../components/ui/inputField";
import Modal from "@mui/material/Modal";
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import { useHistory } from "react-router-dom";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import TextField from "@material-ui/core/TextField";
import Checkbox from '@mui/material/Checkbox';
import { Tabs, Tab } from '@mui/material';

import StorefrontIcon from '@mui/icons-material/Storefront';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import PersonIcon from '@mui/icons-material/Person';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import DescriptionIcon from '@mui/icons-material/Description';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';


export default function Reporting() {
  const [month, setMonth] = useState(null);
  const [year, setYear] = useState(null);
  const [forDisplayingFromMonthAndYear, setForDisplayingFromMonthAndYear] = useState(null);
  const [inputValues, setInputValues] = useState("optionA");
  const [tableData, setTableData] = useState([]);
  const [logData, setLogData] = useState([]);
  const [gstr1FillingSummaryData, setGstr1FillingSummaryData] = useState({});
  const [tableDataSearch, setTableDataSearch] = useState([]);
  const [viewSummary, setViewSummaryDialogOpen] = useState(false);
  const [isLoadingSummary, setIsLoadingSummary] = useState(false);
  const [openEstablisConnectionDrawer, setOpenEstablisConnectionDrawer] =
    useState(false);
  const form = useRef("form");
  const [openOTPModal, setOpenOTPModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [authToken, setAuthToken] = useState("");
  const [username, setUserName] = useState("");
  const [otpApiData, setOtpApidata] = useState({});
  const [establishConnectionButton, setEstablisConnectionButton] = useState(
    "button-outlined-secondary"
  );
  const [authAPiResData, setAuthApiResData] = useState({});
  const [vyanaList, setVyanaList] = useState([]);
  const [fileId, setFileId] = useState('');
  const [logId, setLogId] = useState('');
  const [period, setPeriod] = useState('');
  const [auth_otp, setAuthOTP] = useState("");
  const [filingStatus, setFilingStatus] = useState(false);
  const [isDataLoadingEnabled, setIsDataLoadingEnabled] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [isPreviousMonth, setIsPreviousMonth] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [openPopupSelection, setopenPopupSelection] = useState(false);
  const [selectedReferenceNo, setSelectedReferenceNo] = useState(null);
  const [selectedLogId, setSelectedLogId] = useState(false);
  const [reportData, setReportDate] = useState(null);
  const [permissionRequired, setPermissionRequired] = useState(false);
  const [permissionRequested, setPermissionRequested] = useState({});
  const [apiPermissionRequired, setApiPermissionRequired] = useState(false);
  const [entityEmail, setEntityEmail] = useState('');
  const [useEntityEmail, setUseEntityEmail] = useState(false);
  const [customEmails, setCustomEmails] = useState('');
  const [selectedRow, setSelectedRow] = useState(null);
  const [showPermissionDialog, setShowPermissionDialog] = useState(false);
  let history = useHistory();
  const [emailChips, setEmailChips] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [emailError, setEmailError] = useState('');
  const [isSendingEmail, setIsSendingEmail] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSelectiveInvocie, setIsSelectiveInvoice] = useState(false);
  const [invoiceSelection, setInvoiceSelection] = useState(false);
  const [invoiceCountDialog, setInvoiceCountDialog] = useState({ open: false, data: [], loading: false });
  const [selectiveInvoicesData, setSelectiveInvoicesData] = useState([]);
  const [selectedInvoiceIds, setSelectedInvoiceIds] = useState([]);
  const [selectiveInvoicesId, setSelectiveInvoicesId] = useState(null);

  const [viewShow, setViewShow] = useState(null);
  const [activeTab, setActiveTab] = useState('b2b');

  const [showInvoiceTable, setShowInvoiceTable] = useState(false);
  const [selectedTabLabel, setSelectedTabLabel] = useState('');
  const [selectedHsnIds, setSelectedHsnIds] = useState([]);

  const [originalInvoicesData, setOriginalInvoicesData] = useState([]);
  const [toggleHsn, setToggleHsn] = useState(false);


  const [invoiceSearchQuery, setInvoiceSearchQuery] = useState('');


  const [isSubmittingCardSelection, setIsSubmittingCardSelection] = useState(false);
const [isSavingSelectiveInvoice, setIsSavingSelectiveInvoice] = useState(false);




  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'info'
  });

  const filteredInvoicesData = selectiveInvoicesData.filter((row) => {
    const q = invoiceSearchQuery.toLowerCase();
    if (!q) return true;
    return (
      String(row.document_number || '').toLowerCase().includes(q) ||
      String(row.document_type || '').toLowerCase().includes(q) ||
      String(row.document_date || '').toLowerCase().includes(q) ||
      String(row.cust_legal_name || '').toLowerCase().includes(q) ||
      String(row.cust_gstin || '').toLowerCase().includes(q) ||
      String(row.taxable_value || '').toLowerCase().includes(q) ||
      String(row.non_taxable_adj || '').toLowerCase().includes(q) ||
      String(row.gst_tax_rate || '').toLowerCase().includes(q) ||
      String(row.total_amount || '').toLowerCase().includes(q)
    );
  });

  const handleRequestPermission = () => {
    const currentRecord = tableData.find(item => item.log_id === logId);

    if (currentRecord && currentRecord.request_status === null) {
      setUseEntityEmail(true);
      setEmailChips([]);
      setInputValue('');
      setEmailError('');
      setShowPermissionDialog(true);
    }
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Handle input change
  const handleEmailInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    setEmailError('');
  };

  // Handle key press (Enter, Space, Comma, Tab)
  const handleEmailKeyDown = (e) => {
    if (['Enter', ',', ' ', 'Tab'].includes(e.key)) {
      e.preventDefault();
      addEmailChip();
    } else if (e.key === 'Backspace' && inputValue === '' && emailChips.length > 0) {
      setEmailChips(emailChips.slice(0, -1));
    }
  };

  // Handle input blur
  const handleEmailInputBlur = () => {
    if (inputValue.trim()) {
      addEmailChip();
    }
  };

  // Add email chip
  const addEmailChip = () => {
    const email = inputValue.trim().replace(/,$/, '');

    if (!email) {
      setInputValue('');
      return;
    }

    if (!isValidEmail(email)) {
      setEmailError('Please enter a valid email address');
      return;
    }

    if (emailChips.includes(email)) {
      setEmailError('This email is already added');
      return;
    }

    setEmailChips([...emailChips, email]);
    setInputValue('');
    setEmailError('');
  };

  // Delete email chip
  const handleDeleteEmailChip = (emailToDelete) => {
    setEmailChips(emailChips.filter(email => email !== emailToDelete));
  };

  // Handle paste event
  const handleEmailPaste = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData('text');
    const emails = pastedText
      .split(/[,;\s\n]+/)
      .map(email => email.trim())
      .filter(email => email);

    const validEmails = [];
    const invalidEmails = [];

    emails.forEach(email => {
      if (isValidEmail(email) && !emailChips.includes(email)) {
        validEmails.push(email);
      } else if (!isValidEmail(email)) {
        invalidEmails.push(email);
      }
    });

    if (validEmails.length > 0) {
      setEmailChips([...emailChips, ...validEmails]);
    }

    if (invalidEmails.length > 0) {
      setEmailError(`Invalid email(s): ${invalidEmails.join(', ')}`);
    }
  };


  const handleLog = () => {
    const log_id = localStorage.getItem('selected_log_id');

    if (!log_id) {
      console.error('No log_id found in localStorage');
      return;
    }
    setSelectedLogId(true);
    axios
      .get(`/gstr1_filing_prev_records/${log_id}/${localStorage.getItem('business_entity_id')}`)
      .then((res) => {
        console.log(res.data);

        // If records is an object, wrap it in an array; if it's an array, use it directly
        const records = res.data
          ? Array.isArray(res.data)
            ? res.data
            : [res.data]
          : [];
        setReportDate(records);
        // setTableDataSearch(records); // Uncomment if you need this for search functionality
      })
      .catch((err) => {
        console.error('Error fetching data:', err);
        setReportDate([]);
        // setTableDataSearch([]);
      });

  }

  const handleDownloadPDF = async (returnBase64Only = false) => {
    // Check if data is still loading
    if (isLoadingSummary) {
      setSnackbar({
        open: true,
        message: "Please wait for data to load before downloading PDF.",
        severity: 'warning'
      });
      return null;
    }

    // Check if data exists
    if (!gstr1FillingSummaryData || Object.keys(gstr1FillingSummaryData).length === 0) {
      setSnackbar({
        open: true,
        message: "No data available to generate PDF.",
        severity: 'error'
      });
      return null;
    }

    try {
      // Transform overall summary data
      const transformOverallSummary = (overallSummary) => {
        if (!overallSummary || !overallSummary["Grand Total"]) return [];

        const transformed = [];

        if (overallSummary["Grand Total"]) {
          transformed.push({
            "Particulars (Sheet Name)": "Grand Total",
            "Invoice Count": overallSummary["Grand Total"]["Invoice Count"] ?? "-",
            "Taxable Value": overallSummary["Grand Total"]["Taxable Value"] ?? 0,
            "Tax Value": overallSummary["Grand Total"]["Tax Value"] ?? 0,
            "Invoice Value": overallSummary["Grand Total"]["Invoice Value"] ?? 0,
            bold: true,
          });
        }

        Object.keys(overallSummary).forEach((key) => {
          if (key.startsWith("HSN Summary")) {
            const item = overallSummary[key] || {};
            transformed.push({
              "Particulars (Sheet Name)": key,
              "Invoice Count": item["Invoice Count"] ?? "-",
              "Taxable Value": item["Taxable Value"] ?? 0,
              "Tax Value": item["Tax Value"] ?? 0,
              "Invoice Value": item["Invoice Value"] ?? 0,
              bold: true,
            });
          }
        });

        if (overallSummary["Difference"]) {
          const diff = overallSummary["Difference"];
          transformed.push({
            "Particulars (Sheet Name)": "Difference",
            "Invoice Count": diff["Invoice Count"] ?? "-",
            "Taxable Value": diff["Taxable Value"] ?? 0,
            "Tax Value": diff["Tax Value"] ?? 0,
            "Invoice Value": diff["Invoice Value"] ?? 0,
            bold: true,
          });
        }

        return transformed;
      };

      // Prepare table data
      const summaryReport = (gstr1FillingSummaryData.summary_report || []).map((item, index) => ({
        ...item,
        sNo: index + 1,
        bold: false,
      }));
      const overallSummary = transformOverallSummary(gstr1FillingSummaryData.overall_summary || {});
      const tableData = [...summaryReport, ...overallSummary];

      // Format currency
      const formatRupee = (amount) => {
        return new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: 'INR',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(amount ?? 0);
      };

      // Generate HTML table
      const tableHTML = `
      <div style="width: 1400px; padding: 20px; background: white; font-family: Arial, sans-serif;">
        <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
          <thead>
            <tr style="background-color: #f5f5f5;">
              <th style="border: 1px solid #ddd; padding: 12px; text-align: center;">S.No</th>
              <th style="border: 1px solid #ddd; padding: 12px; text-align: center;">Particulars</th>
              <th style="border: 1px solid #ddd; padding: 12px; text-align: center;">Invoice Count</th>
              <th style="border: 1px solid #ddd; padding: 12px; text-align: center;">Taxable Value/Non-Taxable Value</th>
              <th style="border: 1px solid #ddd; padding: 12px; text-align: center;">Tax Value</th>
              <th style="border: 1px solid #ddd; padding: 12px; text-align: center;">Invoice Value</th>
            </tr>
          </thead>
          <tbody>
            ${tableData.map((value) => {
        const sheetName = value["Particulars (Sheet Name)"];
        const isSpecialRow = sheetName === "Grand Total" || sheetName === "Difference" || sheetName.startsWith("HSN Summary");
        const fontWeight = value.bold ? 'bold' : 'normal';
        const bgColor = value.bold ? '#f0f4ff' : 'white';

        if (isSpecialRow) {
          return `
                  <tr style="background-color: ${bgColor};">
                    <td colspan="2" style="border: 1px solid #ddd; padding: 10px; font-weight: ${fontWeight}; text-align: center;">${value["Particulars (Sheet Name)"] || "-"}</td>
                    <td style="border: 1px solid #ddd; padding: 10px; font-weight: ${fontWeight}; text-align: center;">${value["Invoice Count"] ?? "-"}</td>
                    <td style="border: 1px solid #ddd; padding: 10px; font-weight: ${fontWeight}; text-align: right;">${formatRupee(value["Taxable Value"])}</td>
                    <td style="border: 1px solid #ddd; padding: 10px; font-weight: ${fontWeight}; text-align: right;">${formatRupee(value["Tax Value"])}</td>
                    <td style="border: 1px solid #ddd; padding: 10px; font-weight: ${fontWeight}; text-align: right;">${formatRupee(value["Invoice Value"])}</td>
                  </tr>
                `;
        } else {
          return `
                  <tr style="background-color: ${bgColor};">
                    <td style="border: 1px solid #ddd; padding: 10px; font-weight: ${fontWeight}; text-align: center;">${value.sNo || "-"}</td>
                    <td style="border: 1px solid #ddd; padding: 10px; font-weight: ${fontWeight}; text-align: center;">${value["Particulars (Sheet Name)"] || "-"}</td>
                    <td style="border: 1px solid #ddd; padding: 10px; font-weight: ${fontWeight}; text-align: center;">${value["Invoice Count"] ?? "-"}</td>
                    <td style="border: 1px solid #ddd; padding: 10px; font-weight: ${fontWeight}; text-align: right;">${formatRupee(value["Taxable Value"])}</td>
                    <td style="border: 1px solid #ddd; padding: 10px; font-weight: ${fontWeight}; text-align: right;">${formatRupee(value["Tax Value"])}</td>
                    <td style="border: 1px solid #ddd; padding: 10px; font-weight: ${fontWeight}; text-align: right;">${formatRupee(value["Invoice Value"])}</td>
                  </tr>
                `;
        }
      }).join('')}
          </tbody>
        </table>
      </div>
    `;

      // Create temporary div for rendering
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = tableHTML;
      tempDiv.style.position = 'absolute';
      tempDiv.style.left = '-9999px';
      tempDiv.style.top = '0';
      document.body.appendChild(tempDiv);

      // Wait for rendering
      await new Promise(resolve => setTimeout(resolve, 100));

      // Generate canvas from HTML
      const canvas = await html2canvas(tempDiv, {
        scale: 2,
        backgroundColor: '#ffffff',
        logging: false,
        useCORS: true,
        width: 1400,
        height: tempDiv.scrollHeight
      });

      // Clean up temp div
      document.body.removeChild(tempDiv);

      // Convert canvas to image
      const imgData = canvas.toDataURL('image/png');

      // Create PDF
      const pdf = new jsPDF('l', 'mm', 'a4');

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      const imgProps = pdf.getImageProperties(imgData);
      const imgWidth = pdfWidth - 20;
      const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

      // Add title
      pdf.setFontSize(18);
      pdf.setFont(undefined, 'bold');
      pdf.text('GSTR-1 Filing Summary', pdfWidth / 2, 15, { align: 'center' });

      // Add period
      pdf.setFontSize(14);
      pdf.setFont(undefined, 'normal');
      pdf.text(`Period: ${period}`, pdfWidth / 2, 25, { align: 'center' });

      // Add image to PDF with pagination
      let heightLeft = imgHeight;
      let position = 35;

      pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
      heightLeft -= (pdfHeight - position - 10);

      while (heightLeft > 0) {
        pdf.addPage();
        position = 10 - (imgHeight - heightLeft);
        pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
        heightLeft -= (pdfHeight - 20);
      }

      // Get base64 PDF
      const pdfOutput = pdf.output('arraybuffer');
      const pdfBlob = new Blob([pdfOutput], { type: 'application/pdf' });

      // Convert to base64
      const base64Data = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64 = reader.result.split(',')[1];
          resolve(base64);
        };
        reader.onerror = reject;
        reader.readAsDataURL(pdfBlob);
      });

      // If only base64 is needed, return it without downloading
      if (returnBase64Only) {
        return base64Data;
      }

      // Otherwise, trigger download for the user
      const link = document.createElement('a');
      link.href = URL.createObjectURL(pdfBlob);
      link.download = `GSTR1_Filing_Summary_${period}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);

      return base64Data;

    } catch (error) {
      console.error('Error generating PDF:', error);
      setSnackbar({
        open: true,
        message: "Failed to generate PDF. Please try again.",
        severity: 'error'
      });
      return null;
    }
  };





  const handleCheckboxChange = (id, isChecked) => {
    const updatedReportData = reportData.map((item) =>
      item.id === id
        ? { ...item, selected: isChecked ? true : null }
        : item
    );
    setReportDate(updatedReportData);
  };

  const submitRecord = () => {
    const selectedData = reportData.filter((item) => item.selected !== null);
    const data = {
      record: selectedData.map((item) => ({
        id: item.id,
        erp_code: item.erp_code,
        invoice_no: item.invoice_no,
        invoice_date: item.invoice_date,
        voucher_id: item.voucher_id,
        total_amount: item.total_amount,
        taxable_value: item.taxable_value,
        selected: item.selected,
      })),
    };

    axios
      .post(`/update_selected_prev_records`, data)
      .then((res) => {
        getPreviousMonthLogReport();
        setSnackbar({
          open: true,
          message: res.data.message,
          severity: 'success',
        });
        setOpenPopup(false); // Move setOpenPopup here, inside .then
      })
      .catch((err) => {
        console.error('Error fetching data:', err);
        setSnackbar({
          open: true,
          message: err.response?.data?.message || 'An error occurred', // Use err.response for safer access
          severity: 'error',
        });
        setLogData([]);
        setOpenPopup(false); // Optionally move setOpenPopup here if you want it in case of error too
      });
  };

  const handleSelectAll = (checked) => {
    const updatedReportData = reportData.map((item) => ({
      ...item,
      selected: checked ? true : null,
    }));
    setReportDate(updatedReportData);
  };

  const handleOpenPopup = (log_id) => {
    setSelectedReferenceNo(log_id);
    localStorage.setItem('selected_log_id', log_id);
    setOpenPopup(true);

    axios
      .get(`/gstr1_filing_prev_log/${log_id}/${localStorage.getItem('business_entity_id')}`)
      .then((res) => {
        // If records is an object, wrap it in an array; if it's an array, use it directly
        const records = res.data.records
          ? Array.isArray(res.data.records)
            ? res.data.records
            : [res.data.records]
          : [];
        setLogData(records);
        // setTableDataSearch(records); // Uncomment if you need this for search functionality
      })
      .catch((err) => {
        console.error('Error fetching data:', err);
        setLogData([]);
        // setTableDataSearch([]);
      });
  };

  const handleRun = (value) => {

    console.log(value);

    axios
      .post(`/gstr1_filing_report_generation_second_op`, value)
      .then((res) => {
        getApiForReport()
      })
      .catch((err) => {
        console.error('Error fetching data:', err);
        // setLogData([]);
        // setTableDataSearch([]);
      });
  }

  const hasChanges = selectiveInvoicesData.some((row) => {
    const original = originalInvoicesData.find((o) => o.voucher_id === row.voucher_id);
    if (!original) return false;
    const currentIsSelected = selectedInvoiceIds.includes(row.voucher_id);
    const currentIsHsn = selectedHsnIds.includes(row.voucher_id);
    return (
      currentIsSelected !== (original.is_selected === true) ||
      currentIsHsn !== (original.is_cancelled_invoice === true)
    );
  });
  const getPreviousMonthLogReport = () => {
    const log_id = localStorage.getItem('selected_log_id');

    if (!log_id) {
      console.error('No log_id found in localStorage');
      return;
    }
    // setOpenPopup(true);
    axios
      .get(`/gstr1_filing_prev_log/${log_id}/${localStorage.getItem('business_entity_id')}`)
      .then((res) => {
        // If records is an object, wrap it in an array; if it's an array, use it directly
        const records = res.data.records
          ? Array.isArray(res.data.records)
            ? res.data.records
            : [res.data.records]
          : [];
        setLogData(records);
        // setTableDataSearch(records); // Uncomment if you need this for search functionality
      })
      .catch((err) => {
        console.error('Error fetching data:', err);
        setLogData([]);
        // setTableDataSearch([]);
      });

  }

  const handleClosePopup = () => {
    setOpenPopup(false);
    setSelectedReferenceNo(null);
    setSelectedLogId(false);
  };

  // Handle Snackbar close
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  // Debug OTP modal state changes
  useEffect(() => {
    console.log("openOTPModal state changed:", openOTPModal);
  }, [openOTPModal]);

  useEffect(() => {
    if (tableData.length > 0 && tableData[0]?.entity_email) {
      setEntityEmail(tableData[0].entity_email);
    }
  }, [tableData]);

  // On Change Event To Handle From Tax-Period (Month And Year)
  const inputHandlerForYearAndFromMonth = (v) => {
    setForDisplayingFromMonthAndYear(v);
    const current_date = new Date(v);
    const yy = current_date.getFullYear().toString();
    const mm = (current_date.getMonth() + 1).toString();
    setMonth(mm);
    setYear(yy);
  };

  // Handle confirmation dialog open
  const handleConfirmDialogOpen = () => {
    if (establishConnectionButton === "button-outlined-secondary" && !authToken) {
      setSnackbar({
        open: true,
        message: "Please establish connection first.",
        severity: 'warning'
      });
      setOpenEstablisConnectionDrawer(true);
      return;
    }
    setOpenConfirmDialog(true);
  };

  // Handle confirmation dialog close
  const handleConfirmDialogClose = () => {
    setOpenConfirmDialog(false);
  };

  // Handle confirmation dialog submit
  const handleConfirmSubmit = async () => {
    setOpenConfirmDialog(false);
    await submitPushEstablish();
  };

  const handleSendPermissionEmail = async () => {
    try {
      // Get email list from chips instead of comma-separated string
      const emailList = useEntityEmail ? [entityEmail] : emailChips;

      if (emailList.length === 0) {
        setSnackbar({
          open: true,
          message: "Please provide at least one email address",
          severity: 'error'
        });
        return;
      }

      // Set loading state to true
      setIsSendingEmail(true);
      // Generate PDF as base64 WITHOUT downloading (returnBase64Only = true)
      const base64Data = await handleDownloadPDF(true);

      if (!base64Data) {
        setSnackbar({
          open: true,
          message: "Failed to generate PDF. Please try again.",
          severity: 'error'
        });
        setIsSendingEmail(false);
        return;
      }

      // Prepare payload
      const payload = {
        pdf: base64Data,
        email_ids: emailList,
        business_entity_id: localStorage.getItem("business_entity_id"),
        gst_log_id: logId,
        filing_period: period,
        file_id: fileId
      };

      // Call API
      const response = await axios.post('/gst_send_permission_email', payload);

      if (response.data.status === true) {
        setSnackbar({
          open: true,
          message: response.data.message || "Permission email sent successfully",
          severity: 'success'
        });

        setShowPermissionDialog(false);
        // Reset chips after successful send
        setEmailChips([]);
        setInputValue('');
        setEmailError('');
        getApiForReport();
      } else {
        setSnackbar({
          open: true,
          message: response.data.message || "Failed to send permission email",
          severity: 'error'
        });
      }

    } catch (error) {
      console.error('Error in handleSendPermissionEmail:', error);
      setSnackbar({
        open: true,
        message: error.response?.data?.message || "An error occurred. Please try again.",
        severity: 'error'
      });
    } finally {
      // Reset loading state in finally block to ensure it's always reset
      setIsSendingEmail(false);
    }
  };

  const handleBackNavigation = () => {
    history.push('/Filing');
  };

  const handleSubmit = async () => {
    await submitPushEstablish(); // Simply call the function, as it handles state internally
  };

  const getCurrentLogData = () => {
    const log_id = localStorage.getItem('selected_log_id');
    return tableData.find(item => item.log_id === log_id);
  };

  const isSubmitDisabled = () => {
    const currentLogData = getCurrentLogData();
    return currentLogData?.recon_run_with_prev === true;
  };

  // Modified submit handler that checks the condition
  const handleSubmitRecord = () => {
    if (isSubmitDisabled()) {
      setSnackbar({
        open: true,
        message: "Submit is disabled for records with previous month reconciliation completed.",
        severity: 'warning'
      });
      return;
    }
    submitRecord();
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    zIndex: 1300, // Increased z-index to ensure modal visibility
  };

  // On Change Event To Handle Threshold Value
  const roundValueInputHandler = (e) => {
    let value = e.target.value;
    setInputValues(value);
  };

  // Reset Form
  const handleOpenAndCloseModel = () => {
    setMonth(null);
    setYear(null);
    setForDisplayingFromMonthAndYear(null);
    setInputValues("");
  };

  const closeEstablisConnectionDrawerHamdler = () => {
    setOpenEstablisConnectionDrawer(false);
    // Removed setUserName("") to preserve username
  };

  const closeOptModalHandler = () => {
    setAuthOTP("");
    setOpenOTPModal(false);
  };

  const vyanaAuthHandler = () => {
    let payload = {
      user_name: username,
      business_entity_id: localStorage.getItem("business_entity_id"),
      app_key: otpApiData.app_key,
      transaction_id: otpApiData.transaction_id,
      otp: auth_otp,
    };

    console.log("vyana/authenticate payload:", payload); // Debug payload

    axios
      .post("/vyana/authenticate", payload)
      .then((res) => {
        if (res.data.status === true) {
          setOpenOTPModal(false);
          setOpenEstablisConnectionDrawer(false);
          setEstablisConnectionButton("button-connection-established");
          setAuthApiResData({
            ...authAPiResData,
            sek: res.data.sek,
            auth_token: res.data.auth_token,
          });
          getApiVyanaList();
          setSnackbar({
            open: true,
            message: res.data.message,
            severity: 'success'
          });
          setUserName(""); // Reset username after successful authentication
          setTimeout(() => {
            setEstablisConnectionButton("button-outlined-secondary");
          }, 300000);
        } else {
          setSnackbar({
            open: true,
            message: res.data.error,
            severity: 'error'
          });
          setOpenOTPModal(true);
          setEstablisConnectionButton("button-outlined-secondary");
          setUserName(""); // Reset username after failed authentication
        }
      })
      .catch((error) => {
        console.log(error.response?.message || error.message);
        setOpenOTPModal(true);
        setEstablisConnectionButton("button-outlined-secondary");
        setUserName(""); // Reset username after error
        setSnackbar({
          open: true,
          message: error.response?.message || error.message,
          severity: 'error'
        });
      });
  };

  const getOtpForAuthHandler = () => {
    let payload = {
      user_name: username,
      business_entity_id: localStorage.getItem("business_entity_id"),
    };

    console.log("vyana/send_otp payload:", payload); // Debug payload

    axios
      .post("/vyana/send_otp", payload)
      .then((res) => {
        console.log("API Response:", res.data);
        if (res.data.status === true) {
          if (res.data.is_authenticated === true && res.data.is_otp_sent === false) {
            console.log("Case 1: is_authenticated true, is_otp_sent false");
            setOpenOTPModal(false);
            if (res.data.message === "Connection established.") {
              setSuccessMessage(res.data.message);
              setAuthToken(res.data.auth_token);
            }
            setSnackbar({
              open: true,
              message: res.data.message,
              severity: 'success'
            });
            closeEstablisConnectionDrawerHamdler();
          } else if (res.data.is_authenticated === false && res.data.is_otp_sent === true) {
            console.log("Case 2: Setting openOTPModal to true");
            closeEstablisConnectionDrawerHamdler();
            console.log("setting otp model Open:");
            setOpenOTPModal(true);
            setSnackbar({
              open: true,
              message: res.data.message,
              severity: 'success'
            });
          } else {
            console.log("Case 3: Else block, setting openOTPModal and otpApiData");
            setOpenOTPModal(true);
            setOtpApidata({
              ...otpApiData,
              transaction_id: res.data.transaction_id,
              app_key: res.data.app_key,
            });
          }
        } else {
          console.log("API status false, error:", res.data.error);
          setSnackbar({
            open: true,
            message: res.data.error,
            severity: 'error'
          });
          setOpenOTPModal(false);
          setEstablisConnectionButton("button-outlined-secondary");
        }
      })
      .catch((error) => {
        console.error("API Error:", error.response?.message || error.message);
        setSnackbar({
          open: true,
          message: error.response?.message || error.message,
          severity: 'error'
        });
      });
  };


  const handleOpenPopupSelection = () => {
    setopenPopupSelection(true);
  }


  const fetchSelectiveInvoices = (tabType) => {
    setIsSelectiveInvoice(true);
    setSelectiveInvoicesData([]);
    setSelectedInvoiceIds([]);
    setSelectedHsnIds([]);
    axios
      .post(`/get_selective_invoices`, {
        business_entity_id: parseInt(localStorage.getItem("business_entity_id")),
        report_month: parseInt(month),
        report_year: parseInt(year),
        // hsn_rq_or_not: true,
        record_type: tabType
      })
      .then((res) => {
        const records = res.data.records || [];
        setSelectiveInvoicesData(records);
        setOriginalInvoicesData(records); // 👈 save original
        setSelectiveInvoicesId(res.data.selective_invoices_id);

        setSelectedInvoiceIds(
          records.filter((row) => row.is_selected === true).map((row) => row.voucher_id)
        );
        setSelectedHsnIds(
          records.filter((row) => row.is_cancelled_invoice === true).map((row) => row.voucher_id)
        );
      })
      .catch((err) => console.log(err))
      .finally(() => setIsSelectiveInvoice(false));
  };


  // const fetchSelectiveInvoices = (tabType) => {
  //   setIsSelectiveInvoice(true);
  //   setSelectiveInvoicesData([]);
  //   setSelectedInvoiceIds([]);
  //   axios
  //     .post(`/get_selective_invoices`, { 
  //       business_entity_id: parseInt(localStorage.getItem("business_entity_id")),
  //       report_month: parseInt(month),
  //       report_year: parseInt(year),
  //       hsn_rq_or_not: true,
  //       record_type: tabType
  //     })
  //     .then((res) => {
  //       setSelectiveInvoicesData(res.data.records || []);
  //       setSelectiveInvoicesId(res.data.selective_invoices_id);
  //       setSelectedInvoiceIds(res.data.records.filter((row) => row.is_selected === 1).map((row) => row.id));
  //     })
  //     .catch((err) => console.log(err))
  //     .finally(() => setIsSelectiveInvoice(false));
  // };

  const handleSelectiveInvoice = () => {
    setForDisplayingFromMonthAndYear(null);
    setIsPreviousMonth(null);
    setSelectedInvoiceIds([]);
    setSelectiveInvoicesData([]);
    setShowInvoiceTable(false);
    setSelectedTabLabel('');
    setActiveTab('b2b');
    handleOpenPopupSelection();
  };


  useEffect(() => {
    if (openPopupSelection) {
      fetchSelectiveInvoices(activeTab);
    }
  }, [activeTab]);

  // const handleSelectiveInvoice = () => {
  //   setIsSelectiveInvoice(true)
  //   axios
  //     .post(`/get_selective_invoices`, {
  //       business_entity_id: parseInt(localStorage.getItem("business_entity_id")),
  //       report_month: parseInt(month),
  //       report_year: parseInt(year),
  //       hsn_rq_or_not: true,
  //       record_type: activeTab
  //     })
  //     .then((res) => {
  //       console.log(res.data);
  //       setSelectiveInvoicesData(res.data.records || []);
  //       setSelectiveInvoicesId(res.data.selective_invoices_id);
  //       setSelectedInvoiceIds(res.data.records.filter((row) => row.is_selected === 1).map((row) => row.id));
  //       // getApiForReport();
  //       // form.current.reset();
  //       setForDisplayingFromMonthAndYear(null);
  //       setIsPreviousMonth(null);
  //       handleOpenPopupSelection();

  //       setSelectedInvoiceIds([]);

  //     })
  //     .catch((err) => console.log(err))
  //     .finally(() => {
  //       setIsSelectiveInvoice(false);
  //     });

  // }

  const handleClosePopupSelection = () => {
    setopenPopupSelection(false);
    setShowInvoiceTable(false);
    setSelectedTabLabel('');
    setSelectiveInvoicesData([]);
    setSelectedInvoiceIds([]);
    setSelectedHsnIds([]);
    setOriginalInvoicesData([]);
    setToggleHsn(false);
    setInvoiceSearchQuery('');
  };

const handleSelectAllSelectiveInvoice = (e) => {
  if (e.target.checked) {
    setSelectedInvoiceIds(selectiveInvoicesData.map((row) => row.voucher_id));
    setSelectedHsnIds([]); // 👈 clear HSN when select all
  } else {
    setSelectedInvoiceIds([]);
  }
};


  const handleHsnCheckbox = (voucher_id) => {
  setSelectedHsnIds((prev) => {
    if (prev.includes(voucher_id)) {
      return prev.filter((i) => i !== voucher_id);
    } else {
      // Remove from Select when checking HSN
      setSelectedInvoiceIds((prevSel) => prevSel.filter((i) => i !== voucher_id));
      return [...prev, voucher_id];
    }
  });
};

  // const handleHsnCheckbox = (voucher_id) => {
  //   setSelectedHsnIds((prev) =>
  //     prev.includes(voucher_id) ? prev.filter((i) => i !== voucher_id) : [...prev, voucher_id]
  //   );
  // };

const handleSelectAllHsn = (e) => {
  if (e.target.checked) {
    setSelectedHsnIds(selectiveInvoicesData.map((row) => row.voucher_id));
    setSelectedInvoiceIds([]); // 👈 clear Select when HSN all
  } else {
    setSelectedHsnIds([]);
  }
};

const handleSubmitSelectiveInvoice = () => {
  if (selectiveInvoicesData.length === 0) {
    setSnackbar({ open: true, message: "No records to save.", severity: 'info' });
    return;
  }

  setIsSavingSelectiveInvoice(true);

  // Send ALL records with their current state
  const allRecords = selectiveInvoicesData.map((row) => ({
    ...row,
    is_selected: selectedInvoiceIds.includes(row.voucher_id),
    is_cancelled_invoice: selectedHsnIds.includes(row.voucher_id),
  }));

  axios
    .post(`/update_selective_invoices`, {
      record_id: selectiveInvoicesId,
      records: allRecords,  // 👈 all records
      business_entity_id: parseInt(localStorage.getItem("business_entity_id")),
      report_month: parseInt(month),
      report_year: parseInt(year),
      gstin: localStorage.getItem('gst'),
      record_type: activeTab,
    })
    .then((res) => {
      if (res.data.status) {
        setSnackbar({ open: true, message: res.data.message, severity: 'success' });
      } else {
        setSnackbar({ open: true, message: res.data.message, severity: 'error' });
      }
    })
    .catch((err) => {
      setSnackbar({ open: true, message: err?.response?.data?.message, severity: 'error' });
    })
    .finally(() => {
      setIsSavingSelectiveInvoice(false);
    });
};

const handleSubmitCardSelection = () => {
  setIsSubmittingCardSelection(true);
  axios
    .post(`/run_selective_invoices_gstr1_filing_report`, {
      business_entity_id: parseInt(localStorage.getItem("business_entity_id")),
      report_month: parseInt(month),
      report_year: parseInt(year),
      gstin: localStorage.getItem('gst'),
      is_only_selected: true
    })
    .then((res) => {
      if (res.data.status) {
        setSnackbar({ open: true, message: res.data.message, severity: 'success' });
        handleClosePopupSelection();
      } else {
        setSnackbar({ open: true, message: res.data.message, severity: 'error' });
      }
    })
    .catch((err) => {
      setSnackbar({ open: true, message: err?.response?.data?.message, severity: 'error' });
    })
    .finally(() => {
      setIsSubmittingCardSelection(false);
    });
};

  // const handleSubmitSelectiveInvoice = () => {
  //  const selectedRecords = selectiveInvoicesData
  //   .filter((row) => selectedInvoiceIds.includes(row.voucher_id))
  //   .map((row) => ({
  //     ...row,
  //     is_selected: selectedInvoiceIds.includes(row.voucher_id),
  //     is_cancelled_invoice: selectedHsnIds.includes(row.voucher_id),
  //   }));


  //   axios
  //     .post(`/update_selective_invoices`, {
  //       record_id: selectiveInvoicesId,
  //       records: selectedRecords,
  //       business_entity_id: parseInt(localStorage.getItem("business_entity_id")),
  //       report_month: parseInt(month),
  //       report_year: parseInt(year),
  //       gstin: localStorage.getItem('gst')
  //     })
  //     .then((res) => {
  //       console.log(res.data);
  //       handleClosePopupSelection();
  //       if (res.data.status) {
  //         setSnackbar({ open: true, message: res.data.message, severity: 'success' });
  //         handleClosePopupSelection();
  //       } else {
  //         setSnackbar({ open: true, message: res.data.message, severity: 'error' });
  //       }
  //     })
  //     .catch((err) => {
  //       setSnackbar({ open: true, message: err?.response?.data?.message, severity: 'error' });
  //     });
  // };

  // const handleInvoiceCheckbox = (voucher_id) => {
  //   setSelectedInvoiceIds((prev) =>
  //     prev.includes(voucher_id) ? prev.filter((i) => i !== voucher_id) : [...prev, voucher_id]
  //   );
  // };

  const handleInvoiceCheckbox = (voucher_id) => {
  setSelectedInvoiceIds((prev) => {
    if (prev.includes(voucher_id)) {
      return prev.filter((i) => i !== voucher_id);
    } else {
      // Remove from HSN when selecting
      setSelectedHsnIds((prevHsn) => prevHsn.filter((i) => i !== voucher_id));
      return [...prev, voucher_id];
    }
  });
};

  // Submit Button
  const onSubmitHandler = () => {
    let optionFlag = inputValues === "optionA";
    setIsSubmitting(true);
    axios
      .post(`/report_generation`, {
        functionality: "report_generation",
        business_entity_id: parseInt(localStorage.getItem("business_entity_id")),
        report_month: parseInt(month),
        report_year: parseInt(year),
        option: optionFlag,
        is_previous_month: isPreviousMonth,
        recon_run_with_prev: false,
        gstin: localStorage.getItem('gst')
      })
      .then((res) => {
        console.log(res.data);
        getApiForReport();
        // form.current.reset();
        setForDisplayingFromMonthAndYear(null);
        setIsPreviousMonth(null);
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const getApiForReport = () => {
    axios
      .get(`/get_cws_gst_log/${localStorage.getItem("business_entity_id")}`)
      .then((res) => {
        const records = res.data.records || [];
        setTableData(records);
        setTableDataSearch(records);

        // Store the top-level permission_required and entity_email
        setApiPermissionRequired(res.data.permission_required || false);
        setEntityEmail(res.data.entity_email || '');
        setInvoiceSelection(res.data.invoice_selection === true);
      })
      .catch((err) => {
        console.log(err);
        setTableData([]);
        setTableDataSearch([]);
        setApiPermissionRequired(false);
        setEntityEmail('');
        setInvoiceSelection(false);
      });
  };

  const isPermissionRequired = apiPermissionRequired === true;
  const isRequestApproved = selectedRow?.request_status === "Approved";

  // Determine if button should be shown
  const shouldShowFileGSTR1Button = (() => {
    if (apiPermissionRequired === false) {
      return true; // Always show button when permission is not required
    }

    // When permission is required, find the current record
    const currentRecord = tableData.find(item => item.log_id === logId);

    // Show button only if request_status is "Approved"
    return currentRecord?.request_status === "Approved";
  })();

  useEffect(() => {
    getApiForReport();
  }, []);

  const downloadBase64File = (contentType, base64Data, fileName) => {
    const linkSource = `data:${contentType};base64,${base64Data}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  const handleDownloadExcel = (file_id) => {
  axios
    .post(`/download_gstr_upload_file`, {
      file_id: file_id,
      extension: "xlsx",
    })
    .then((res) => {
      if (res.data.status === "success" && res.data.download_url) {
        window.location.href = res.data.download_url;
      } else {
        setSnackbar({
          open: true,
          message: "Unable to download!",
          severity: 'error'
        });
      }
    })
    .catch((error) => {
      setSnackbar({
        open: true,
        message: "Server Error, Try After Some Time",
        severity: 'error'
      });
    });
};

  // const handleDownloadExcel = (file_id) => {
  //   const contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  //   const filename = `GSTR-1_Filing.xlsx`;

  //   axios
  //     .post(`/download_gstr_upload_file`, {
  //       file_id: file_id,
  //       extension: "xlsx",
  //     })
  //     .then((res) => {
  //       if (res.data.status === "pass") {
  //         downloadBase64File(contentType, res.data.file, filename);
  //       } else {
  //         setSnackbar({
  //           open: true,
  //           message: "Unable to download!",
  //           severity: 'error'
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       setSnackbar({
  //         open: true,
  //         message: "Server Error, Try After Some Time",
  //         severity: 'error'
  //       });
  //     });
  // };

  const handleAlternateDownload = (log_id) => {
    const contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const filename = `GSTR-1_ErrorFiling.xlsx`;

    axios
      .post(`/gst_save_error_report`, { log_id })
      .then((res) => {
        if (res.data.status === "pass") {
          downloadBase64File(contentType, res.data.file, filename);
        } else {
          setSnackbar({
            open: true,
            message: res.data.description || "Unable to download",
            severity: 'error'
          });
        }
      })
      .catch((error) => {
        setSnackbar({
          open: true,
          message: error.response?.data?.description || "Server error, please try again later",
          severity: 'error'
        });
      });
  };

  const handleSearchEvent = (e) => {
    let searchValue = e.target.value.trim();
    const searchFile = tableDataSearch.filter((v) => {
      return (
        String(v.period).toLowerCase().indexOf(searchValue.toLowerCase()) >= 0 ||
        String(v.date).indexOf(searchValue) >= 0 ||
        String(v.status).toLowerCase().indexOf(searchValue.toLowerCase()) >= 0
      );
    });
    setTableData(searchFile);
  };

  const onClickRefresh = () => {

  }

  const handleViewSummaryDialog = (item) => {
    const log_id = item.log_id
    setViewSummaryDialogOpen(true);
    setIsLoadingSummary(true);
    axios
      .get(`/view_summary_gst_save/${log_id}`)
      .then((res) => {
        setGstr1FillingSummaryData(res.data || {});
        setIsLoadingSummary(false);
        setFileId(item.file_id || '');
        setLogId(item.log_id || '');
        setPeriod(item.period || '');
        setSelectedRow(item);
        if (res.data.filing_status === true) {
          setFilingStatus(true);
        } else {
          setFilingStatus(false);
        }
      })
      .catch((err) => {
        console.error(err);
        setGstr1FillingSummaryData({});
        setIsLoadingSummary(false);
        setFileId('');
        setLogId('');
        setPeriod('');
        setSelectedRow(null);
        setSnackbar({
          open: true,
          message: "Failed to fetch summary data",
          severity: 'error'
        });
      });
  };

  const handleViewSummaryCloseDialog = () => {
    setViewSummaryDialogOpen(false);
    setGstr1FillingSummaryData({});
  };


  const handleViewShowCloseDialog = () => {
    setViewShow(false);

  }

  const getApiVyanaList = () => {
    axios
      .get(`/vyana/get_list/${localStorage.getItem("business_entity_id")}`)
      .then((res) => {
        if (res.data.status === true) {
          setVyanaList(res.data.data);
        } else {
        }
      })
      .catch((error) => {
      });
  };

  const submitPushEstablish = () => {
    // if (establishConnectionButton === "button-outlined-secondary" && !authToken) {
    //   alert("Please establish connection.");
    //   return;
    // }

    const payload = {
      business_entity_id: localStorage.getItem("business_entity_id"),
      user_name: username,
      transaction_id: otpApiData.transaction_id,
      app_key: otpApiData.app_key,
      sek: authAPiResData.sek,
      auth_token: authAPiResData.auth_token,
      file_id: fileId,
      log_id: logId,
      period: period,
    };

    setIsDataLoadingEnabled(true); // Use the correct setter
    axios
      .post("/vyana/gst_save", payload)
      .then((res) => {
        setIsDataLoadingEnabled(false); // Reset loading state
        if (res.data.status === true) {
          getApiVyanaList();
          getApiForReport();
          setSnackbar({
            open: true,
            message: "GSTR-1 filed successfully.",
            severity: 'success'
          });

          handleViewSummaryCloseDialog()

        } else {
          getApiVyanaList();
          setSnackbar({
            open: true,
            message: res.data.error?.error?.message || "Failed to file GSTR-1.",
            severity: 'error',
          });

          handleViewSummaryCloseDialog()

        }
      })
      .catch((error) => {
        setIsDataLoadingEnabled(false); // Reset loading state on error
        console.error("API error:", error.response?.message || error.message);
        setSnackbar({
          open: true,
          message: "Failed to file GSTR-1. Please try again.",
          severity: 'error'
        });

        handleViewSummaryCloseDialog()

      });
  };


  const handleInvoiceCountClick = (value) => {
    if (!value["Invoice Count"] || value["Invoice Count"] <= 0) return;

    const particulars = value["Particulars (Sheet Name)"];

    setInvoiceCountDialog({ open: true, data: [], headers: [], loading: true, particulars: particulars });

    const payload = {
      log_id: logId,
      type: value["Particulars (Sheet Name)"]
    };

    axios
      .post("/get_detailed_gst1_filing_invoices", payload)
      .then((response) => {
        if (response.data.status === "pass") {
          setInvoiceCountDialog({
            open: true,
            headers: response.data.order_list || [],
            data: response.data.detailed_summary || [],
            loading: false,
            particulars: particulars
          });
        } else {
          setInvoiceCountDialog({ open: true, data: [], headers: [], loading: false, particulars: particulars });
          setSnackbar({ open: true, message: response.data.message, severity: 'error' });
        }
      })
      .catch((error) => {
        setInvoiceCountDialog({ open: true, data: [], headers: [], loading: false, particulars: particulars });
        setSnackbar({ open: true, message: "Failed to fetch invoice details", severity: 'error' });
      });
  };

  const Gstr1FillingSummaryDialog = ({ gstr1FillingSummaryData, isLoadingSummary }) => {
    const transformOverallSummary = (overallSummary) => {
      if (!overallSummary || !overallSummary["Grand Total"]) return [];

      const transformed = [];

      if (overallSummary["Grand Total"]) {
        transformed.push({
          "Particulars (Sheet Name)": "Grand Total",
          "Invoice Count": overallSummary["Grand Total"]["Invoice Count"] ?? "-",
          "Taxable Value": overallSummary["Grand Total"]["Taxable Value"] ?? 0,
          "Tax Value": overallSummary["Grand Total"]["Tax Value"] ?? 0,
          "Invoice Value": overallSummary["Grand Total"]["Invoice Value"] ?? 0,
          bold: true,
        });
      }

      Object.keys(overallSummary).forEach((key) => {
        if (key.startsWith("HSN Summary")) {
          const item = overallSummary[key] || {};
          transformed.push({
            "Particulars (Sheet Name)": key,
            "Invoice Count": item["Invoice Count"] ?? "-",
            "Taxable Value": item["Taxable Value"] ?? 0,
            "Tax Value": item["Tax Value"] ?? 0,
            "Invoice Value": item["Invoice Value"] ?? 0,
            bold: true,
          });
        }
      });

      if (overallSummary["Difference"]) {
        const diff = overallSummary["Difference"];
        transformed.push({
          "Particulars (Sheet Name)": "Difference",
          "Invoice Count": diff["Invoice Count"] ?? "-",
          "Taxable Value": diff["Taxable Value"] ?? 0,
          "Tax Value": diff["Tax Value"] ?? 0,
          "Invoice Value": diff["Invoice Value"] ?? 0,
          bold: true,
        });
      }

      return transformed;
    };

    const combineSummaryData = (data) => {
      const summaryReport = (data.summary_report || []).map((item, index) => ({
        ...item,
        sNo: index + 1,
        bold: false,
      }));
      const overallSummary = transformOverallSummary(data.overall_summary || {});
      return [...summaryReport, ...overallSummary];
    };

    const tableData = gstr1FillingSummaryData
      ? combineSummaryData(gstr1FillingSummaryData)
      : [];

    return (
      <div
        style={{
          overflowX: 'auto',
          overflowY: 'auto',
          maxHeight: '70vh',
          width: '100%',
          border: '1px solid #e0e0e0',
          borderRadius: '4px',
        }}
      >
        <table
          style={{
            borderCollapse: 'collapse',
            tableLayout: 'auto',
            width: 'max-content',
            minWidth: '100%',
          }}
        >
          <thead>
            <tr>
              {['S.No', 'Particulars', 'Invoice Count', 'Taxable Value/Non-Taxable Value', 'Tax Value', 'Invoice Value'].map((header, i) => (
                <th
                  key={i}
                  style={{
                    padding: '12px 20px',
                    whiteSpace: 'nowrap',
                    position: 'sticky',
                    top: 0,
                    zIndex: 2,
                    backgroundColor: '#f0f4f8',
                    borderBottom: '2px solid #ccc',
                    borderRight: '1px solid #ddd',
                    textAlign: 'center',
                    minWidth: i === 0 ? '60px' : '180px',
                  }}
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {isLoadingSummary ? (
              <tr>
                <td colSpan={6} style={{ textAlign: 'center', color: 'blue', padding: '30px' }}>
                  Loading...
                </td>
              </tr>
            ) : tableData.length > 0 ? (
              tableData.map((value, index) => {
                const sheetName = value["Particulars (Sheet Name)"];
                const isSpecialRow =
                  sheetName === "Grand Total" ||
                  sheetName === "Difference" ||
                  sheetName.startsWith("HSN Summary");

                const formatRupee = (amount) => {
                  return new Intl.NumberFormat('en-IN', {
                    style: 'currency',
                    currency: 'INR',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(amount ?? 0);
                };

                const cellStyle = {
                  padding: '10px 20px',
                  whiteSpace: 'nowrap',
                  borderBottom: '1px solid #eee',
                  borderRight: '1px solid #eee',
                  textAlign: 'center',
                  fontWeight: value.bold ? 'bold' : 'normal',
                  minWidth: '180px',
                };

                const rowStyle = {
                  backgroundColor: value.bold ? '#f0f4ff' : (index % 2 === 0 ? '#ffffff' : '#f9fafb'),
                };

                return (
                  <tr key={index} style={rowStyle}>
                    {isSpecialRow ? (
                      <>
                        <td colSpan={2} style={cellStyle}>
                          {value["Particulars (Sheet Name)"] || "-"}
                        </td>
                        <td style={cellStyle}>
                          {value["Invoice Count"] ?? "-"}
                        </td>
                        <td style={{ ...cellStyle, textAlign: 'right' }}>
                          {formatRupee(value["Taxable Value"])}
                        </td>
                        <td style={{ ...cellStyle, textAlign: 'right' }}>
                          {formatRupee(value["Tax Value"])}
                        </td>
                        <td style={{ ...cellStyle, textAlign: 'right' }}>
                          {formatRupee(value["Invoice Value"])}
                        </td>
                      </>
                    ) : (
                      <>
                        <td style={{ ...cellStyle, minWidth: '60px' }}>
                          {value.sNo || "-"}
                        </td>
                        <td style={cellStyle}>
                          {value["Particulars (Sheet Name)"] || "-"}
                        </td>
                        <td style={cellStyle}>
                          {value["Invoice Count"] != null && value["Invoice Count"] > 0 ? (
                            <span
                              onClick={() => handleInvoiceCountClick(value)}
                              style={{
                                color: "#2563eb",
                                cursor: "pointer",
                                textDecoration: "underline",
                                fontWeight: "inherit",
                              }}
                            >
                              {value["Invoice Count"]}
                            </span>
                          ) : (
                            value["Invoice Count"] ?? "-"
                          )}
                        </td>
                        <td style={{ ...cellStyle, textAlign: 'right' }}>
                          {formatRupee(value["Taxable Value"])}
                        </td>
                        <td style={{ ...cellStyle, textAlign: 'right' }}>
                          {formatRupee(value["Tax Value"])}
                        </td>
                        <td style={{ ...cellStyle, textAlign: 'right' }}>
                          {formatRupee(value["Invoice Value"])}
                        </td>
                      </>
                    )}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={6} style={{ textAlign: 'center', color: 'red', padding: '30px' }}>
                  No Data Found!!
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
    // return (
    //   <div className="responsive-table">
    //     <table className="custome-table" >
    //       <thead>
    //         <tr>
    //           <th>S.No</th>
    //           <th>Particulars</th>
    //           <th>Invoice Count</th>
    //           <th>Taxable Value/Non-Taxable Value</th>
    //           <th>Tax Value</th>
    //           <th>Invoice Value</th>
    //         </tr>
    //       </thead>
    //       <tbody>
    //         {isLoadingSummary ? (
    //           <tr>
    //             <td style={{ color: "blue", textAlign: "center" }} colSpan={6}>
    //               Loading...
    //             </td>
    //           </tr>
    //         ) : tableData.length > 0 ? (
    //           tableData.map((value, index) => {
    //             const sheetName = value["Particulars (Sheet Name)"];
    //             const isSpecialRow =
    //               sheetName === "Grand Total" ||
    //               sheetName === "Difference" ||
    //               sheetName.startsWith("HSN Summary");

    //             // Formatter for Indian Rupee
    //             const formatRupee = (amount) => {
    //               return new Intl.NumberFormat('en-IN', {
    //                 style: 'currency',
    //                 currency: 'INR',
    //                 minimumFractionDigits: 2,
    //                 maximumFractionDigits: 2,
    //               }).format(amount ?? 0);
    //             };

    //             return (
    //               <tr key={index}>
    //                 {isSpecialRow ? (
    //                   <>
    //                     <td
    //                       style={{ fontWeight: value.bold ? "bold" : "normal" }}
    //                       colSpan={2}
    //                     >
    //                       {value["Particulars (Sheet Name)"] || "-"}
    //                     </td>
    //                     <td style={{ fontWeight: value.bold ? "bold" : "normal" }}>
    //                       {value["Invoice Count"] ?? "-"}
    //                     </td>
    //                     <td style={{ fontWeight: value.bold ? "bold" : "normal" }}>
    //                       {formatRupee(value["Taxable Value"])}
    //                     </td>
    //                     <td style={{ fontWeight: value.bold ? "bold" : "normal" }}>
    //                       {formatRupee(value["Tax Value"])}
    //                     </td>
    //                     <td style={{ fontWeight: value.bold ? "bold" : "normal" }}>
    //                       {formatRupee(value["Invoice Value"])}
    //                     </td>
    //                   </>
    //                 ) : (
    //                   <>
    //                     <td style={{ fontWeight: value.bold ? "bold" : "normal" }}>
    //                       {value.sNo || "-"}
    //                     </td>
    //                     <td style={{ fontWeight: value.bold ? "bold" : "normal" }}>
    //                       {value["Particulars (Sheet Name)"] || "-"}
    //                     </td>
    //                     <td style={{ fontWeight: value.bold ? "bold" : "normal" }}>
    //                       {value["Invoice Count"] != null && value["Invoice Count"] > 0 ? (
    //                         <span
    //                           onClick={() => handleInvoiceCountClick(value)}
    //                           style={{
    //                             color: "#2563eb",
    //                             cursor: "pointer",
    //                             textDecoration: "underline",
    //                             fontWeight: "inherit",
    //                           }}
    //                         >
    //                           {value["Invoice Count"]}
    //                         </span>
    //                       ) : (
    //                         value["Invoice Count"] ?? "-"
    //                       )}
    //                     </td>
    //                     <td style={{ fontWeight: value.bold ? "bold" : "normal" }}>
    //                       {formatRupee(value["Taxable Value"])}
    //                     </td>
    //                     <td style={{ fontWeight: value.bold ? "bold" : "normal" }}>
    //                       {formatRupee(value["Tax Value"])}
    //                     </td>
    //                     <td style={{ fontWeight: value.bold ? "bold" : "normal" }}>
    //                       {formatRupee(value["Invoice Value"])}
    //                     </td>
    //                   </>
    //                 )}
    //               </tr>
    //             );
    //           })
    //         ) : (
    //           <tr>
    //             <td style={{ color: "red", textAlign: "center" }} colSpan={6}>
    //               No Data Found!!
    //             </td>
    //           </tr>
    //         )}
    //       </tbody>
    //     </table>
    //   </div>
    // );
  };


  const Gstr1Save = () => {

  }

  const downloadBase64Excel = (contentType, base64Data, fileName) => {
    const linkSource = `data:${contentType};base64,${base64Data}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };


  const handleDownloadSaveExcel = (reference_no) => {
    const business_entity_id = localStorage.getItem("business_entity_id");
    const reference_id = reference_no;
    const payload = { business_entity_id, reference_id };
    axios
      .post("/vyana/gst_return_status_download_excel", payload)
      .then((response) => {
        if (response.data.status === "success") {
          setSnackbar({
            open: true,
            message: response.data.message,
            severity: 'success'
          });
        } else if (response.data.status === "error") {
          setSnackbar({
            open: true,
            message: response.data.message,
            severity: 'error'
          });
        }
        const contentType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const base64Data = response.data.file;
        if (base64Data) {
          downloadBase64Excel(contentType, base64Data, "GSTR1_Save_Status.xlsx");
        } else {
          console.error("Base64 data is missing in the response");
        }
      })
      .catch((error) => {
        console.log(error)
      })
  };

  const handleClick = async (reference_no) => {
    try {
      const business_entity_id = localStorage.getItem("business_entity_id");
      const reference_id = reference_no;
      const payload = { business_entity_id, reference_id };
      const response = await axios.post("/vyana/gst_return_status/", payload);

      if (response.data.status === "success") {
        setSnackbar({
          open: true,
          message: response.data.message,
          severity: 'success'
        });
      } else if (response.data.status === "error") {
        setSnackbar({
          open: true,
          message: response.data.message,
          severity: 'error'
        });
      }
    } catch (error) {
      console.error("Error during API call:", error);
      setSnackbar({
        open: true,
        message: "Error checking GST return status",
        severity: 'error'
      });
    }
  };

  const handleRefresh = (item) => {
    const payloadData = {
      "business_entity_id": localStorage.getItem("business_entity_id"),
      "reference_id": item.reference_no,
      "period": item.period
    }
    axios.post("/vyana/get_gstr_save_updated_status", payloadData)
      .then(() => {
        getApiVyanaList();
        getApiForReport();
      }).catch(() => {

      })
  }

  console.log("openOTPModal state:", openOTPModal);
  return (
    <React.Fragment>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '15px 20px',
          backgroundColor: '#f5f5f5',
        }}
      >
        <Tooltip title="Back" arrow>
          <IconButton
            onClick={handleBackNavigation}
            sx={{
              borderRadius: '50%',
              padding: '6px',
              color: '#263238',
              fontSize: '20px',
              backgroundColor: '#ffffff',
              height: '36px',
              width: '36px',
              '&:hover': {
                backgroundColor: '#455a64',
                color: '#ffffff',
              },
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
              transition: 'background-color 0.3s ease',
            }}
          >
            <ArrowBackIcon sx={{ fontSize: '20px' }} />
          </IconButton>
        </Tooltip>
        {
          successMessage === "Connection established." ? (
            <button variant="contained"
              className="button-outlined-primary" color="success" style={{ fontSize: '13px', padding: '4px 8px', bottom: '4px', backgroundColor: '#03406d', color: 'white' }}
            >
              Connection Established
            </button>
          ) : (
            <button
              className={establishConnectionButton}
              onClick={() => setOpenEstablisConnectionDrawer(true)}
            >
              {establishConnectionButton === "button-outlined-secondary"
                ? "Establish Connection"
                : "Connection Established"
              }
            </button>
          )
        }
      </Box>
      <BoxWrapper boxTitle="GSTR-1 Filing">
        <ValidatorForm
          useRef="form"
          onSubmit={onSubmitHandler}
          onError={(errors) => console.log(errors)}
        >
          <Grid container spacing={1} alignItems="center"> {/* Reduced spacing, align items vertically */}
            <Grid item xs={12} sm={5}> {/* Adjusted size for date picker */}
              <label style={{ display: 'block', marginBottom: '4px' }}>
                Reporting Month<span style={{ color: 'red' }}>*</span>:
              </label>
              <ValidatedDatePicker
                placeholder="Month & Year"
                errorMessages={["This field is required"]}
                validators={["required"]}
                value={forDisplayingFromMonthAndYear}
                onChange={(v) => inputHandlerForYearAndFromMonth(v)}
                fullWidth
              />
            </Grid>
            <Grid
              item
              xs={4}
              sm={1}
              container
              alignItems="center"
              justifyContent="center"
              style={{
                marginLeft: '-39px',
                marginRight: '-44px',
                marginTop: '16px',
              }}
            >
              <input
                type="checkbox"
                checked={isPreviousMonth}
                disabled={invoiceSelection}
                onChange={(e) => setIsPreviousMonth(e.target.checked)} // Update checkbox state
                style={{
                  transform: 'scale(1.1)',
                }}
                aria-label="Previous Month"
                title="Include Previous Month" // Tooltip text
              />
            </Grid>
            {invoiceSelection && (
              <Grid item xs={4} sm={1}>
                <button
                  className="button-primary"
                  type="button"
                  disabled={!forDisplayingFromMonthAndYear || isSelectiveInvocie}
                  onClick={handleSelectiveInvoice}
                  style={{
                    width: '100%',
                    padding: '8px',
                    fontSize: '14px',
                    marginTop: '16px',
                    cursor: (!forDisplayingFromMonthAndYear || isSelectiveInvocie) ? 'not-allowed' : 'pointer',
                    opacity: (!forDisplayingFromMonthAndYear || isSelectiveInvocie) ? 0.6 : 1
                  }}
                >
                  {isSelectiveInvocie ? 'Invoice...' : 'Selective'}
                </button>
              </Grid>
            )}
            <Grid item xs={4} sm={1}>
              <button
                className="button-primary"
                type="submit"
                disabled={isSubmitting || (invoiceSelection)}  // 👈 updated
                style={{
                  width: '100%',
                  padding: '8px',
                  fontSize: '14px',
                  marginTop: '16px',
                  cursor: (isSubmitting || invoiceSelection) ? 'not-allowed' : 'pointer',
                  opacity: (isSubmitting || invoiceSelection) ? 0.6 : 1
                }}
              >
                {isSubmitting ? 'Submitting...' : 'Submit'}
              </button>
            </Grid>
            {/* <Grid item xs={4} sm={1}> 
              <button
                className="button-primary"
                type="submit"
                disabled={isSubmitting}
                style={{ width: '100%', padding: '8px', fontSize: '14px', marginTop: '16px', cursor: isSubmitting ? 'not-allowed' : 'pointer', opacity: isSubmitting ? 0.6 : 1 }}
              >
                {isSubmitting ? 'Submitting...' : 'Submit'}
              </button>
            </Grid> */}
            <Grid item xs={4} sm={1}> {/* Consistent button size */}
              <button
                className="button-outlined-secondary"
                type="button"
                onClick={handleOpenAndCloseModel}
                style={{ width: '100%', padding: '8px', fontSize: '14px', marginTop: '16px' }}
              >
                Cancel
              </button>
            </Grid>
          </Grid>
          {/* <Grid container spacing={3}>
            <Grid item sm={5}>
              <label>
                Reporting Month<span style={{ color: "red" }}>*</span>:
              </label>
              <ValidatedDatePicker
                placeholder="Month & Year"
                errorMessages={["This field is required"]}
                validators={["required"]}
                value={forDisplayingFromMonthAndYear}
                onChange={(v) => inputHandlerForYearAndFromMonth(v)}
              />
            </Grid>
            <Grid item sm={1}>
              <input
                type="checkbox"
                style={{ marginTop: "28px" }}
              />
            </Grid>
            <Grid item sm={1}>
              <button
                style={{ marginTop: "28px", width: "100%", padding: "7px" }}
                className="button-primary"
                type="submit"
              >
                Submit
              </button>
            </Grid>
            <Grid item sm={1}>
              <button
                className="button-outlined-secondary"
                style={{ marginTop: "28px", width: "100%", padding: "7px" }}
                type="button"
                onClick={handleOpenAndCloseModel}
              >
                Cancel
              </button>
            </Grid>
          </Grid> */}
        </ValidatorForm>
      </BoxWrapper>

      <BoxWrapper
        boxTitle="GSTR-1 Filing Report"
        enableSearchInput={true}
        searchInputPlaceholder="Search..."
        searchInputOnchange={handleSearchEvent}
        enableAddButton={true}
        addButtonLabel="Refresh"
        addButtonHandlerFn={getApiForReport}
      >
        <div className="responsive-table">
          <table className="custome-table">
            <thead>
              <tr>
                <th>Period</th>
                <th>Report Generated Date</th>
                <th>Previous Month</th>
                <th>Filing Status</th>
                <th>GSTR Save Status</th>
                <th>GSTR Save Error</th>
                <th>Action</th>
                <th>Report</th>
                <th>Error Report</th>
                <th>Viewsummary GSTR 1 Filing Report</th>
              </tr>
            </thead>
            <tbody>
              {tableData?.map((value) => (
                <tr key={value.file_id}>
                  <td>{value.period}</td>
                  <td>{value.date}</td>
                  <td>
                    {value.is_previous_month === true && value.recon_run_with_prev !== true && (
                      <>
                        <VisibilityIcon
                          style={{ cursor: 'pointer', color: '#63acf7' }}
                          onClick={() => handleOpenPopup(value.log_id)}
                        />
                        <RefreshIcon
                          style={{ cursor: 'pointer', color: '#63acf7' }}
                          onClick={() => handleRun(value)}
                        />
                      </>
                    )}
                    {value.recon_run_with_prev === true && (
                      <VisibilityIcon
                        style={{ cursor: 'pointer', color: '#63acf7' }}
                        onClick={() => handleOpenPopup(value.log_id)}
                      />
                    )}
                  </td>
                  <td>{value.status}</td>
                  <td>{value.gstr1_save_status}</td>
                  {/* <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                    <DownloadIcon
                      style={{
                        color: value.gstr1_save_status !== null && value.status === 'Pass' ? '#63acf7' : 'grey',
                        cursor: value.gstr1_save_status !== null && value.status === 'Fail' ? 'pointer' : 'not-allowed',
                      }}
                      onClick={() => {
                        if (value.gstr1_save_status !== null && value.gstr1_save_status === 'Pass') {
                          handleDownloadSaveExcel(value.reference_no);
                        }
                      }}
                    />
                  </td> */}
                  <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                    <DownloadIcon
                      style={{
                        color: value.reference_no && (value.gstr1_save_status === 'Fail' || value.reference_no) ? '#63acf7' : 'grey',
                        cursor: value.reference_no && (value.gstr1_save_status === 'Fail' || value.reference_no) ? 'pointer' : 'not-allowed',
                      }}
                      onClick={() => {
                        if (value.reference_no && (value.gstr1_save_status === 'Fail' || value.reference_no)) {
                          handleDownloadSaveExcel(value.reference_no);
                        }
                      }}
                    />
                  </td>
                  <td>
                    <VisibilityIcon
                      style={{
                        color:
                          value.gstr1_save_status === 'Fail'
                            ? 'red'
                            : value.gstr1_save_status === 'Pass'
                              ? '#63acf7'
                              : 'grey',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        // if (value.gstr1_save_status === 'Pass') {
                        handleClick(value.reference_no);
                        // }
                      }}
                    />
                    {value.gstr1_save_status === 'In-progress' && (
                      <RefreshIcon
                        color="primary"
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleRefresh(value)}
                      />
                    )}
                  </td>
                  <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                    <DownloadIcon
                      style={{
                        color:
                          value.file_id != null && !(value.status === 'In-Progress' || value.status === 'Uploads') ? '#63acf7' : 'grey',
                        cursor:
                          value.file_id != null && !(value.status === 'In-Progress' || value.status === 'Uploads') ? 'pointer' : 'not-allowed',
                      }}
                      onClick={() => {
                        if (value.file_id != null && !(value.status === 'In-Progress' || value.status === 'Uploads')) {
                          handleDownloadExcel(value.file_id);
                        }
                      }}
                    />
                  </td>
                  <td>
                    <DownloadIcon
                      style={{
                        color:
                          !(value.status === 'In-Progress' || value.status === 'Uploads') && value.status === 'Fail' ? '#63acf7' : 'grey',
                        cursor:
                          !(value.status === 'In-Progress' || value.status === 'Uploads') && value.status === 'Fail' ? 'pointer' : 'not-allowed',
                      }}
                      onClick={() => {
                        if (!(value.status === 'In-Progress' || value.status === 'Uploads') && value.status === 'Fail') {
                          handleAlternateDownload(value.log_id);
                        }
                      }}
                    />
                  </td>
                  <td>
                    <VisibilityIcon
                      style={{
                        color:
                          !(value.status === 'In-Progress' || value.status === 'Uploads') && value.status === 'Pass' ? '#63acf7' : 'grey',
                        cursor:
                          !(value.status === 'In-Progress' || value.status === 'Uploads') && value.status === 'Pass' ? 'pointer' : 'not-allowed',
                      }}
                      onClick={() => {
                        if (!(value.status === 'In-Progress' || value.status === 'Uploads') && value.status === 'Pass') {
                          handleViewSummaryDialog(value);
                        }
                      }}
                    />
                  </td>
                </tr>
              ))}
              {tableData.length <= 0 && (
                <tr>
                  <td style={{ color: "red", textAlign: "center" }} colSpan={6}>
                    No Data Found!!
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </BoxWrapper>

      <Dialog open={openPopup} onClose={handleClosePopup}
        fullWidth
        maxWidth="xl"
        PaperProps={{
          sx: {
            borderRadius: 4,
            boxShadow: 24,
            px: 2,
            py: 1,
            marginLeft: 8,
            bgcolor: 'background.default',
            // minHeight: '70%',
          }
        }}>
        {/* <DialogTitle>GSTR-1 Filing Log Report Previous Month</DialogTitle> */}
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            pb: 1,
            borderBottom: 1,
            borderColor: 'divider',
          }}
        >
          <Box display="flex" alignItems="center" gap={1}>
            <BusinessIcon color="primary" />
            <Typography variant="h6" fontWeight="bold">
              GSTR-1 Filing Log Report Previous Month
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <BoxWrapper
            boxTitle="GSTR-1 Filing Log Report Previous Month"
            // enableSearchInput={true}
            // searchInputPlaceholder="Search..."
            // searchInputOnchange={handleSearchEvent}
            enableAddButton={true}
            addButtonLabel="Refresh"
            addButtonHandlerFn={getPreviousMonthLogReport}
          >
            <div className="responsive-table">
              <table className="custome-table">
                <thead>
                  <tr>
                    <th>Run Date</th>
                    <th>Report Month</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(logData) && logData.length > 0 ? (
                    logData.map((value) => (
                      <tr key={value.log_id}>
                        <td>{value.record_run_date}</td>
                        <td>{value.report_month}</td>
                        <td>{value.status}</td>
                        <td>
                          {value.status === 'Pass' ? (
                            <VisibilityIcon
                              style={{ cursor: 'pointer', color: '#63acf7' }}
                              onClick={() => handleLog(value.log_id)}
                            />
                          ) : (
                            <VisibilityIcon
                              style={{ cursor: 'not-allowed', color: '#ccc' }}
                            />
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td style={{ color: 'red', textAlign: 'center' }} colSpan={3}>
                        No Data Found!!
                      </td>
                    </tr>
                  )}
                </tbody>
                {/* <tbody>
                  {logData?.map((value) => (
                    <tr>
                      <td>{value.record_run_date}</td>
                      <td>{value.report_month}</td>
                      <td>{value.status}</td>
                      <td></td>
                    </tr>
                  ))}
                  {logData?.length <= 0 && (
                    <tr>
                      <td style={{ color: "red", textAlign: "center" }} colSpan={6}>
                        No Data Found!!
                      </td>
                    </tr>
                  )}
                </tbody> */}
              </table>
            </div>
          </BoxWrapper>
          {selectedLogId && (
            <BoxWrapper
              boxTitle="Report of Previous Month"
              // enableSearchInput={true}
              // searchInputPlaceholder="Search..."
              // searchInputOnchange={handleSearchEvent}
              // enableAddButton={true}
              enableAddButton={true}
              addButtonLabel="Submit"
              addButtonHandlerFn={handleSubmitRecord}
            >
              <div className="responsive-table">
                <table className="custome-table">
                  <thead>
                    <tr>
                      <th>
                        <input
                          type="checkbox"
                          onChange={(e) => handleSelectAll(e.target.checked)}
                          disabled={isSubmitDisabled()}
                          checked={Array.isArray(reportData) && reportData.length > 0 && reportData.every((item) => item.selected !== null)}
                        />
                      </th>
                      <th>ERP Code</th>
                      <th>Invoice No</th>
                      <th>Invoice Date</th>
                      <th>Invoice Type</th>
                      <th>Voucher Id</th>
                      <th>Total Amount</th>
                      <th>Taxable Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(reportData) && reportData.length > 0 ? (
                      reportData.map((value) => (
                        <tr key={value.log_id}>
                          <td>
                            <input
                              type="checkbox"
                              disabled={isSubmitDisabled()}
                              checked={value.selected !== null} // Checkbox checked if selected is not null
                              onChange={(e) => handleCheckboxChange(value.id, e.target.checked)} // Handle checkbox change
                            />
                          </td>
                          <td>{value.erp_code}</td>
                          <td>{value.document_no}</td>
                          <td>{value.document_date}</td>
                          <td>{value.document_type}</td>
                          <td>{value.voucher_id}</td>
                          <td>{value.total_amount}</td>
                          <td>{value.taxable_value}</td>

                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td style={{ color: 'red', textAlign: 'center' }} colSpan={3}>
                          No Data Found!!
                        </td>
                      </tr>
                    )}
                  </tbody>
                  {/* <tbody>
                  {logData?.map((value) => (
                    <tr>
                      <td>{value.record_run_date}</td>
                      <td>{value.report_month}</td>
                      <td>{value.status}</td>
                      <td></td>
                    </tr>
                  ))}
                  {logData?.length <= 0 && (
                    <tr>
                      <td style={{ color: "red", textAlign: "center" }} colSpan={6}>
                        No Data Found!!
                      </td>
                    </tr>
                  )}
                </tbody> */}
                </table>
              </div>
            </BoxWrapper>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePopup}>Close</Button>
        </DialogActions>
      </Dialog>


      {/* Add these states at top of component */}
      {/* const [showInvoiceTable, setShowInvoiceTable] = useState(false); */}
      {/* const [selectedTabLabel, setSelectedTabLabel] = useState(''); */}

<Dialog open={openPopupSelection} onClose={handleClosePopupSelection}
  fullWidth maxWidth="xl"
  PaperProps={{
    sx: { borderRadius: 4, boxShadow: 24, px: 2, py: 1, marginLeft: 8, bgcolor: 'background.default' }
  }}>

  {/* TITLE */}
  <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1, borderBottom: 1, borderColor: 'divider' }}>
    <Box display="flex" alignItems="center" gap={1}>
      <BusinessIcon color="primary" />
      <Typography variant="h6" fontWeight="bold">
        {showInvoiceTable ? `GSTR-1 Selection — ${selectedTabLabel}` : 'GSTR-1 Selection Invoice'}
      </Typography>
    </Box>

    {/* RIGHT SIDE */}
    <Box display="flex" alignItems="center" gap={2}>
      {showInvoiceTable && (
        <input
          type="text"
          placeholder="Search..."
          value={invoiceSearchQuery}
          onChange={(e) => setInvoiceSearchQuery(e.target.value)}
          style={{
            padding: '6px 12px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            fontSize: '13px',
            width: '220px',
            outline: 'none',
          }}
        />
      )}
      <IconButton onClick={handleClosePopupSelection} size="small">
        <CloseIcon />
      </IconButton>
    </Box>
  </DialogTitle>

  {/* CONTENT */}
  <DialogContent dividers sx={{ px: 3, py: 3, overflow: 'auto' }}>

    {/* ── CARD VIEW ── */}
    {!showInvoiceTable && (
      <Box>
        <Typography variant="body2" sx={{ color: '#78909c', mb: 2.5, fontSize: '13px' }}>
          Select a category to view invoices
        </Typography>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
            gap: 2,
          }}
        >
          {[
            { value: 'b2b',      label: 'B2B, SEZ, DE', Icon: StorefrontIcon,    bg: '#e8f4fd', border: '#90caf9', iconBg: '#bbdefb', iconColor: '#1565c0' },
            { value: 'b2cl',     label: 'B2CL',         Icon: PeopleAltIcon,     bg: '#f3e8fd', border: '#ce93d8', iconBg: '#e1bee7', iconColor: '#6a1b9a' },
            { value: 'b2cs',     label: 'B2CS',         Icon: PersonIcon,        bg: '#e8fdf3', border: '#80cbc4', iconBg: '#b2dfdb', iconColor: '#00695c' },
            { value: 'cdnr',     label: 'CDNR',         Icon: NoteAddIcon,       bg: '#fff8e1', border: '#ffe082', iconBg: '#fff3cd', iconColor: '#e65100' },
            { value: 'cdnur',    label: 'CDNUR',        Icon: DescriptionIcon,   bg: '#fce8e8', border: '#ef9a9a', iconBg: '#ffcdd2', iconColor: '#b71c1c' },
            { value: 'export',   label: 'Export',       Icon: FlightTakeoffIcon, bg: '#e8f5e9', border: '#a5d6a7', iconBg: '#c8e6c9', iconColor: '#2e7d32' },
            { value: 'exempted', label: 'Exempted',     Icon: VerifiedUserIcon,  bg: '#fef3e8', border: '#ffcc80', iconBg: '#ffe0b2', iconColor: '#bf360c' },
          ].map((tab) => (
            <Box
              key={tab.value}
              onClick={() => {
                setActiveTab(tab.value);
                setSelectedTabLabel(tab.label);
                setShowInvoiceTable(true);
                setInvoiceSearchQuery('');
                fetchSelectiveInvoices(tab.value); // ✅ fetch directly with tab.value
              }}
              sx={{
                cursor: 'pointer',
                borderRadius: 3,
                border: `1.5px solid ${tab.border}`,
                backgroundColor: tab.bg,
                px: 2.5,
                py: 2.5,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: 1.5,
                transition: 'all 0.18s ease',
                '&:hover': {
                  transform: 'translateY(-3px)',
                  boxShadow: `0 6px 16px rgba(0,0,0,0.10)`,
                  borderColor: tab.iconColor,
                },
                '&:active': {
                  transform: 'translateY(0px)',
                },
              }}
            >
              {/* Icon Circle */}
              <Box
                sx={{
                  width: 52,
                  height: 52,
                  borderRadius: '50%',
                  backgroundColor: tab.iconBg,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {React.createElement(tab.Icon, { sx: { fontSize: 28, color: tab.iconColor } })}
              </Box>

              {/* Label */}
              <Typography
                variant="body2"
                fontWeight={600}
                sx={{ color: tab.iconColor, fontSize: '13px', lineHeight: 1.4 }}
              >
                {tab.label}
              </Typography>

              {/* Arrow */}
              <Box sx={{ alignSelf: 'flex-end', mt: 'auto', opacity: 0.7 }}>
                {React.createElement(ArrowForwardIcon, { sx: { fontSize: 18, color: tab.iconColor } })}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    )}

    {/* ── TABLE VIEW ── */}
    {showInvoiceTable && (
      <div style={{ maxHeight: '420px', overflowY: 'auto', overflowX: 'auto' }}>
        {isSelectiveInvocie ? (
          <Box sx={{ textAlign: 'center', py: 5, color: '#1976d2', fontSize: '14px' }}>
            Loading invoices...
          </Box>
        ) : (
          <table className="custome-table">
            <thead>
              <tr>
                {/* SELECT ALL header */}
                <th style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>
                  <Checkbox
                    checked={selectiveInvoicesData.length > 0 && selectedInvoiceIds.length === selectiveInvoicesData.length}
                    indeterminate={
                      activeTab !== 'exempted' &&
                      selectedInvoiceIds.length > 0 &&
                      selectedInvoiceIds.length < selectiveInvoicesData.length
                    }
                    onChange={handleSelectAllSelectiveInvoice}
                    color="primary"
                  />
                  Select All
                </th>

                {/* Opt-Out Invoices header */}
                <th style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>
                  <Checkbox
                    checked={selectiveInvoicesData.length > 0 && selectedHsnIds.length === selectiveInvoicesData.length}
                    indeterminate={selectedHsnIds.length > 0 && selectedHsnIds.length < selectiveInvoicesData.length}
                    onChange={handleSelectAllHsn}
                    color="primary"
                    disabled={activeTab === 'exempted'}
                  />
                  Opt-Out Invoices
                </th>

                <th style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>Document No</th>

                {/* ✅ Legal Name — only for b2b, b2cl, cdnur, export */}
                {['b2b', 'b2cl', 'cdnr', 'export'].includes(activeTab) && (
                  <th style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>Legal Name</th>
                )}

                <th style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>Document Type</th>
                <th style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>Document Date</th>
                <th style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>GSTIN</th>
                <th style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>Taxable Value</th>
                <th style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>GST Tax Rate</th>
                <th style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>Total Amount</th>
              </tr>
            </thead>
            <tbody>
              {filteredInvoicesData.length === 0 ? (
                <tr>
                  {/* ✅ colSpan adjusts based on whether Legal Name column is shown */}
                  <td
                    colSpan={['b2b', 'b2cl', 'cdnr', 'cdnur', 'export'].includes(activeTab) ? 10 : 9}
                    style={{ textAlign: 'center', color: '#999', padding: '32px' }}
                  >
                    {invoiceSearchQuery ? 'No matching records found' : 'No records found'}
                  </td>
                </tr>
              ) : (
                filteredInvoicesData.map((row) => (
                  <tr key={row.voucher_id}>

                    {/* Select checkbox */}
                    <td>
                      <Checkbox
                        checked={selectedInvoiceIds.includes(row.voucher_id)}
                        onChange={() => handleInvoiceCheckbox(row.voucher_id)}
                        color="primary"
                        disabled={activeTab === 'exempted'}
                      />
                    </td>

                    {/* Opt-Out checkbox */}
                    <td>
                      <Checkbox
                        checked={selectedHsnIds.includes(row.voucher_id)}
                        onChange={() => handleHsnCheckbox(row.voucher_id)}
                        color="primary"
                        disabled={activeTab === 'exempted'}
                      />
                    </td>

                    <td>{row.document_number}</td>

                    {/* ✅ Legal Name cell — only for b2b, b2cl, cdnur, export */}
                    {['b2b', 'b2cl', 'cdnr',  'export'].includes(activeTab) && (
                      <td>{row.cust_legal_name}</td>
                    )}

                    <td>{row.document_type}</td>
                    <td>{row.document_date}</td>
                    <td>{row.cust_gstin}</td>
                    <td>{row.taxable_value}</td>
                    <td>{row.gst_tax_rate}</td>
                    <td>{row.total_amount}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
    )}

  </DialogContent>

  {/* ACTIONS */}
  <DialogActions sx={{ px: 3, py: 2 }}>

    {/* CARD VIEW — Cancel | TABLE VIEW — Back */}
    {showInvoiceTable ? (
      <Button
        variant="outlined"
        onClick={() => {
          setShowInvoiceTable(false);
          setSelectiveInvoicesData([]);
          setSelectedInvoiceIds([]);
          setSelectedTabLabel('');
          setInvoiceSearchQuery('');
        }}
      >
        Back
      </Button>
    ) : (
      <Button variant="outlined" onClick={handleClosePopupSelection}>Cancel</Button>
    )}

    {/* CARD VIEW — Submit */}
    {!showInvoiceTable && (
      <Button
        variant="contained"
        color="primary"
        onClick={handleSubmitCardSelection}
        disabled={isSubmittingCardSelection}
        startIcon={
          isSubmittingCardSelection ? (
            <HourglassBottomIcon
              sx={{
                animation: 'spin 1s linear infinite',
                '@keyframes spin': {
                  '0%': { transform: 'rotate(0deg)' },
                  '100%': { transform: 'rotate(360deg)' },
                },
              }}
            />
          ) : null
        }
      >
        {isSubmittingCardSelection ? 'Submitting...' : 'Submit'}
      </Button>
    )}

    {/* TABLE VIEW — Save */}
    {showInvoiceTable && (
      <Button
        variant="contained"
        color="primary"
        disabled={!hasChanges || isSavingSelectiveInvoice}
        onClick={handleSubmitSelectiveInvoice}
        startIcon={
          isSavingSelectiveInvoice ? (
            <HourglassBottomIcon
              sx={{
                animation: 'spin 1s linear infinite',
                '@keyframes spin': {
                  '0%': { transform: 'rotate(0deg)' },
                  '100%': { transform: 'rotate(360deg)' },
                },
              }}
            />
          ) : null
        }
      >
        {isSavingSelectiveInvoice ? 'Saving...' : 'Save'}
      </Button>
    )}
  </DialogActions>

</Dialog>

      {/* <Dialog open={openPopupSelection} onClose={handleClosePopupSelection}
        fullWidth maxWidth="xl"
        PaperProps={{
          sx: { borderRadius: 4, boxShadow: 24, px: 2, py: 1, marginLeft: 8, bgcolor: 'background.default' }
        }}>
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1, borderBottom: 1, borderColor: 'divider' }}>
          <Box display="flex" alignItems="center" gap={1}>
            <BusinessIcon color="primary" />
            <Typography variant="h6" fontWeight="bold">GSTR-1 Selection Invoice</Typography>
          </Box>
          <IconButton onClick={handleClosePopupSelection} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers sx={{ px: 3, py: 2, overflow: 'hidden' }}>
          <Tabs
            value={activeTab}
            onChange={(e, newValue) => setActiveTab(newValue)}
            sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}
          >
            <Tab label="B2B, SEZ, DE" value="b2b" />
            <Tab label="B2CL" value="b2cl" />
            <Tab label="B2CS" value="b2cs" />
            <Tab label="CDNR" value="cdnr" />
            <Tab label="CDNUR" value="cdnur" />
            <Tab label="Export" value="export" />
            <Tab label="Exempted" value="exempted" />
          </Tabs>
          <div style={{ maxHeight: '400px', overflowY: 'auto', overflowX: 'auto' }}>
            <table className="custome-table">
              <thead>
                <tr>
                  <th style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>
                    <Checkbox
                      checked={
                        selectiveInvoicesData.length > 0 &&
                        selectedInvoiceIds.length === selectiveInvoicesData.length
                      }
                      indeterminate={
                        selectedInvoiceIds.length > 0 &&
                        selectedInvoiceIds.length < selectiveInvoicesData.length
                      }
                      onChange={handleSelectAllSelectiveInvoice}
                      color="primary"
                    />
                    Select All
                  </th>
                  <th style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>Invoice No</th>
                  <th style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>Document Type</th>
                  <th style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>Invoice Date</th>
                  <th style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>Customer Name</th>
                  <th style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>GSTIN</th>
                  <th style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>Invoice Type</th>
                  <th style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>Taxable Value</th>
                  <th style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>Tax Amount</th>
                  <th style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>Total Amount</th>
                </tr>
              </thead>
              <tbody>
                {selectiveInvoicesData.length === 0 ? (
                  <tr>
                    <td colSpan="9" style={{ textAlign: 'center' }}>N
                      o records found</td>
                  </tr>
                ) : (
                  selectiveInvoicesData
                    .filter(row => row.tab_type === activeTab)  // adjust field name to match your data
                    .map((row) => (
                      <tr key={row.id}>
                        <td>
                          <Checkbox
                            checked={selectedInvoiceIds.includes(row.id)}
                            onChange={() => handleInvoiceCheckbox(row.id)}
                            color="primary"
                          />
                        </td>
                        <td>{row.invoice_no}</td>
                        <td>{row.document_type
                        }</td>
                        <td>{row.invoice_date}</td>
                        <td>{row.cust_legal_name}</td>
                        <td>{row.cust_gstin}</td>
                        <td>{row.gst_invoice_type}</td>
                        <td>{row.taxable_value}</td>
                        <td>{row.tax_amount}</td>
                        <td>{row.total_amount}</td>
                      </tr>
                    ))
                )}
              </tbody>
            </table>
          </div>
        </DialogContent> */}

      {/* <DialogContent dividers sx={{ px: 3, py: 2, overflow: 'auto' }}>
          <table className="custome-table">
            <thead>
              <tr>
                <th>Select</th>
                <th>Invoice No</th>
                <th>Invoice Date</th>
                <th>Customer Name</th>
                <th>GSTIN</th>
                <th>Invoice Type</th>
                <th>Taxable Value</th>
                <th>Tax Amount</th>
                <th>Total Amount</th>
              </tr>
            </thead>
            <tbody>
              {selectiveInvoicesData.length === 0 ? (
                <tr>
                  <td colSpan="9" style={{ textAlign: 'center' }}>No records found</td>
                </tr>
              ) : (
                selectiveInvoicesData.map((row) => (
                  <tr key={row.id}>
                    <td>
                      <Checkbox
                        checked={selectedInvoiceIds.includes(row.id)}
                        onChange={() => handleInvoiceCheckbox(row.id)}
                        color="primary"
                      />
                    </td>
                    <td>{row.invoice_no}</td>
                    <td>{row.invoice_date}</td>
                    <td>{row.cust_legal_name}</td>
                    <td>{row.cust_gstin}</td>
                    <td>{row.gst_invoice_type}</td>
                    <td>{row.taxable_value}</td>
                    <td>{row.tax_amount}</td>
                    <td>{row.total_amount}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </DialogContent> */}

      {/* <DialogActions sx={{ px: 3, py: 2 }}>
          <Button variant="outlined" onClick={handleClosePopupSelection}>Cancel</Button>
          <Button
            variant="contained"
            color="primary"
            disabled={selectedInvoiceIds.length === 0}  // enabled only when at least one is checked
            // onClick={() => console.log("Selected IDs:", selectedInvoiceIds)}
            onClick={(handleSubmitSelectiveInvoice)}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog> */}


      <Dialog
        open={viewShow}
        onClose={handleViewShowCloseDialog}
        fullWidth
        maxWidth="xl"
        PaperProp s={{
          sx: {
            borderRadius: 4,
            boxShadow: 24,
            px: 2,
            py: 1,
            marginLeft: 8,
            bgcolor: 'background.default',
            width: '95vw',
            minHeight: '85vh',
          }
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            pb: 1,
            borderBottom: 1,
            borderColor: 'divider',
          }}
        >
          <Box display="flex" alignItems="center" gap={1}>
            <BusinessIcon color="primary" />
            <Typography variant="h6" fontWeight="bold">
              GSTR-1 Filing Save
            </Typography>
          </Box>
          <IconButton
            onClick={handleViewSummaryCloseDialog}
            size="small"
            disabled={isDataLoadingEnabled}
            sx={{
              '&.Mui-disabled': {
                opacity: 0.5, // Customize disabled appearance
                cursor: 'not-allowed',
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers sx={{ px: 3, py: 2, flex: 1, overflow: 'auto' }}>
          <Gstr1Save />
        </DialogContent>

        <DialogActions
          sx={{
            justifyContent: 'flex-end',
            px: 3,
            py: 2,
            borderTop: 1,
            borderColor: 'divider',
            bgcolor: 'background.default',
          }}
        >
          {isDataLoadingEnabled && (
            <Button
              variant="outlined"
              color="info"
              startIcon={
                <HourglassBottomIcon
                  sx={{
                    animation: 'spin 1s linear infinite',
                    '@keyframes spin': {
                      '0%': { transform: 'rotate(0deg)' },
                      '100%': { transform: 'rotate(360deg)' },
                    },
                  }}
                />
              }
              disabled
            >
              Filing...
            </Button>
          )}

        </DialogActions>
      </Dialog>


      <Dialog
        open={viewSummary}
        onClose={handleViewSummaryCloseDialog}
        fullWidth
        maxWidth="xl"
        PaperProps={{
          sx: {
            borderRadius: 4,
            boxShadow: 24,
            px: 2,
            py: 1,
            marginLeft: 8,
            bgcolor: 'background.default',
            width: '95vw',
            minHeight: '85vh',
          }
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            pb: 1,
            borderBottom: 1,
            borderColor: 'divider',
          }}
        >
          <Box display="flex" alignItems="center" gap={1}>
            <BusinessIcon color="primary" />
            <Typography variant="h6" fontWeight="bold">
              GSTR-1 Filing Summary
            </Typography>
          </Box>
          <IconButton
            onClick={handleViewSummaryCloseDialog}
            size="small"
            disabled={isDataLoadingEnabled}
            sx={{
              '&.Mui-disabled': {
                opacity: 0.5, // Customize disabled appearance
                cursor: 'not-allowed',
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers sx={{ px: 3, py: 2, flex: 1, overflow: 'auto' }}>
          <Gstr1FillingSummaryDialog
            gstr1FillingSummaryData={gstr1FillingSummaryData}
            isLoadingSummary={isLoadingSummary}
          />
        </DialogContent>

        <DialogActions
          sx={{
            justifyContent: 'flex-end',
            px: 3,
            py: 2,
            borderTop: 1,
            borderColor: 'divider',
            bgcolor: 'background.default',
          }}
        >
          {isDataLoadingEnabled && (
            <Button
              variant="outlined"
              color="info"
              startIcon={
                <HourglassBottomIcon
                  sx={{
                    animation: 'spin 1s linear infinite',
                    '@keyframes spin': {
                      '0%': { transform: 'rotate(0deg)' },
                      '100%': { transform: 'rotate(360deg)' },
                    },
                  }}
                />
              }
              disabled
            >
              Filing...
            </Button>
          )}
          {!isDataLoadingEnabled && (
            <>
              {apiPermissionRequired === true && (
                <Tooltip
                  title={tableData.find(item => item.log_id === logId)?.request_status || ""}
                >
                  <span>
                    <button
                      onClick={handleRequestPermission}
                      disabled={tableData.find(item => item.log_id === logId)?.request_status !== null}
                      className="button-outlined-secondary"
                      style={{
                        cursor: tableData.find(item => item.log_id === logId)?.request_status !== null ? 'not-allowed' : 'pointer',
                        opacity: tableData.find(item => item.log_id === logId)?.request_status !== null ? 0.6 : 1,
                      }}
                    >
                      REQUEST PERMISSION
                    </button>
                  </span>
                </Tooltip>
              )}
             
              <button
                onClick={() => handleDownloadPDF(false)}
                className="button-outlined-secondary"
              >
                DOWNLOAD PDF
              </button>
              {successMessage === "Connection established." ? (
                <button
                  className="button-outlined-primary"
                  color="success"
                  style={{ fontSize: '13px', padding: '4px 8px', backgroundColor: '#03406d', color: 'white' }}
                >
                  Connection Established
                </button>
              ) : (
                <button
                  className={establishConnectionButton}
                  onClick={() => setOpenEstablisConnectionDrawer(true)}
                >
                  {establishConnectionButton === "button-outlined-secondary"
                    ? "Establish Connection"
                    : "Connection Established"}
                </button>
              )}
              {shouldShowFileGSTR1Button && (
                <Button
                  className={classes.buttonprimary}
                  onClick={handleConfirmDialogOpen}
                  variant="outlined"
                  type="submit"
                  disabled={!filingStatus}
                  sx={{
                    '&.Mui-disabled': {
                      color: '#7393B3 !important',
                      cursor: 'not-allowed !important',
                    },
                    '&.Mui-disabled:hover': {
                      cursor: 'not-allowed !important',
                    },
                  }}
                >
                  File GSTR - 1
                </Button>
              )}
              {/* <Button
                onClick={handleViewSummaryCloseDialog}
                variant="outlined"
                disabled={isDataLoadingEnabled}
              >
                Close
              </Button> */}
            </>
          )}
        </DialogActions>
      </Dialog>

      <Dialog
        open={openConfirmDialog}
        onClose={handleConfirmDialogClose}
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: 24,
            p: 2,
            bgcolor: 'background.default',
          }
        }}
      >
        <DialogTitle sx={{ fontWeight: 'bold' }}>
          Confirm GSTR-1 Filing
        </DialogTitle>
        <DialogContent>
          <Typography>
            Do you really want to file GSTR-1?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleConfirmSubmit}
            variant="contained"
            color="primary"
          >
            Yes
          </Button>
          <Button
            onClick={handleConfirmDialogClose}
            variant="outlined"
            color="secondary"
          >
            No
          </Button>
        </DialogActions>
      </Dialog>

      {/* <RightDrawer
        drawerName="Establish Connection"
        open={openEstablisConnectionDrawer}
      >
        <ValidatorForm
          ref={form}
          onSubmit={getOtpForAuthHandler}
          onError={(errors) => console.log(errors)}
        >
          <Inputfield
            textLabel="User Name"
            inputType="text"
            name="user_name"
            value={username}
            textOnchangeFunction={(e) => setUserName(e.target.value)}
            requiredField="*"
            validator={["required"]}
            errorMsg={["This field is required"]}
          />
          <div className="mt-20">
            <button className="button-primary" type="submit">
              Submit
            </button>
            <button
              className="button-outlined-secondary"
              type="button"
              onClick={closeEstablisConnectionDrawerHamdler}
            >
              Close
            </button>
          </div>
        </ValidatorForm>
      </RightDrawer> */}


      <Dialog
        open={openEstablisConnectionDrawer}
        onClose={closeEstablisConnectionDrawerHamdler}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: 24,
            p: 2,
            bgcolor: 'background.default',
          },
        }}
      >
        <DialogTitle style={{ fontWeight: '600' }}>Establish Connection</DialogTitle>
        <DialogContent>
          <ValidatorForm
            ref={form}
            onSubmit={getOtpForAuthHandler}
            onError={(errors) => console.log(errors)}
          >
            <Inputfield
              textLabel="User Name"
              inputType="text"
              name="user_name"
              value={username}
              textOnchangeFunction={(e) => setUserName(e.target.value)}
              requiredField="*"
              validator={["required"]}
              errorMsg={["This field is required"]}
            />
            <div className="mt-20">
              <button className="button-primary" type="submit">
                Submit
              </button>
              <button
                className="button-outlined-secondary"
                type="button"
                onClick={closeEstablisConnectionDrawerHamdler}
              >
                Close
              </button>
            </div>
          </ValidatorForm>
        </DialogContent>
      </Dialog>

      {/* Permission Request Dialog */}
      <Dialog
        open={showPermissionDialog}
        onClose={(event, reason) => {
          // Prevent closing during sending
          if (isSendingEmail) {
            return;
          }
          // Allow closing only when not sending
          setShowPermissionDialog(false);
          setEmailChips([]);
          setInputValue('');
          setEmailError('');
        }}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: 24,
            p: 2,
            bgcolor: 'background.default',
          }
        }}
      >
        <DialogTitle sx={{ fontWeight: 'bold' }}>
          Request Permission
        </DialogTitle>
        <DialogContent>
          <Typography style={{ marginBottom: '20px' }}>
            Do you want to request permission for GST data access?
          </Typography>

          <Typography variant="body2" style={{ marginBottom: '10px', color: '#666' }}>
            Select email option:
          </Typography>

          <FormControlLabel
            control={
              <Radio
                checked={useEntityEmail}
                onChange={(e) => {
                  setUseEntityEmail(e.target.checked);
                  if (e.target.checked) {
                    setEmailChips([]);
                    setInputValue('');
                    setEmailError('');
                  }
                }}
              />
            }
            label={
              <Typography variant="body2">
                Default: <strong>{entityEmail || 'Not available'}</strong>
              </Typography>
            }
          />

          <FormControlLabel
            control={
              <Radio
                checked={!useEntityEmail}
                onChange={(e) => {
                  setUseEntityEmail(!e.target.checked);
                }}
              />
            }
            label={<Typography variant="body2">Enter custom email(s)</Typography>}
          />

          {!useEntityEmail && (
            <Box sx={{ mt: 2 }}>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                Enter email addresses (press Enter, Space, Comma, or Tab to add)
              </Typography>

              <Box
                sx={{
                  border: '1px solid',
                  borderColor: emailError ? 'error.main' : 'grey.300',
                  borderRadius: 1,
                  padding: 1,
                  minHeight: 120,
                  maxHeight: 200,
                  overflowY: 'auto',
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 1,
                  alignItems: 'flex-start',
                  '&:focus-within': {
                    borderColor: emailError ? 'error.main' : 'primary.main',
                    borderWidth: 2,
                  },
                }}
                onClick={() => document.getElementById('email-chip-input').focus()}
              >
                {emailChips.map((email, index) => (
                  <Chip
                    key={index}
                    label={email}
                    onDelete={() => handleDeleteEmailChip(email)}
                    color="primary"
                    variant="outlined"
                    size="small"
                    sx={{
                      maxWidth: '100%',
                      '& .MuiChip-label': {
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }
                    }}
                  />
                ))}

                <TextField
                  id="email-chip-input"
                  value={inputValue}
                  onChange={handleEmailInputChange}
                  onKeyDown={handleEmailKeyDown}
                  onBlur={handleEmailInputBlur}
                  onPaste={handleEmailPaste}
                  placeholder={emailChips.length === 0 ? "Enter email addresses..." : ""}
                  variant="standard"
                  sx={{
                    flex: 1,
                    minWidth: 200,
                    '& .MuiInput-root': {
                      '&:before, &:after': {
                        display: 'none',
                      },
                    },
                    '& input': {
                      padding: '4px 0',
                    }
                  }}
                  InputProps={{
                    disableUnderline: true,
                  }}
                />
              </Box>

              {emailError && (
                <Typography variant="caption" color="error" sx={{ mt: 1, display: 'block' }}>
                  {emailError}
                </Typography>
              )}

              {emailChips.length > 0 && (
                <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                  {emailChips.length} email{emailChips.length !== 1 ? 's' : ''} added
                </Typography>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleSendPermissionEmail}
            variant="contained"
            color="primary"
            disabled={(!useEntityEmail && emailChips.length === 0) || isSendingEmail}
            startIcon={isSendingEmail ? <HourglassBottomIcon sx={{
              animation: 'spin 1s linear infinite',
              '@keyframes spin': {
                '0%': { transform: 'rotate(0deg)' },
                '100%': { transform: 'rotate(360deg)' },
              },
            }} /> : null}
          >
            {isSendingEmail ? 'SENDING...' : 'SEND'}
          </Button>
          <Button
            onClick={() => {
              setShowPermissionDialog(false);
              setEmailChips([]);
              setInputValue('');
              setEmailError('');
            }}
            variant="outlined"
            color="secondary"
            disabled={isSendingEmail}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={invoiceCountDialog.open}
        onClose={() => setInvoiceCountDialog({ open: false, data: [], headers: [], loading: false })}
        fullWidth
        maxWidth="xl"
        PaperProps={{
          sx: { borderRadius: 4, boxShadow: 24, px: 2, py: 1, bgcolor: 'background.default', width: '95vw' }
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex', justifyContent: 'space-between',
            alignItems: 'center', pb: 1, borderBottom: 1, borderColor: 'divider',
          }}
        >
          <Box display="flex" alignItems="center" gap={1}>
            <BusinessIcon color="primary" />
            <Typography variant="h6" fontWeight="bold"> {invoiceCountDialog?.particulars || 'Invoice Details'}</Typography>
          </Box>
          <IconButton onClick={() => setInvoiceCountDialog({ open: false, data: [], headers: [], loading: false })} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ px: 2, py: 2, overflow: 'hidden' }}>
          <div
            style={{
              overflowX: 'auto',
              overflowY: 'auto',
              maxHeight: '60vh',
              width: '100%',
              border: '1px solid #e0e0e0',
              borderRadius: '4px',
            }}
          >
            <table
              style={{
                borderCollapse: 'collapse',
                tableLayout: 'auto',
                width: 'max-content',
                minWidth: '100%',
              }}
            >
              <thead>
                <tr>
                  <th
                    style={{
                      padding: '12px 20px',
                      whiteSpace: 'nowrap',
                      position: 'sticky',
                      top: 0,
                      zIndex: 2,
                      backgroundColor: '#f0f4f8',
                      borderBottom: '2px solid #ccc',
                      borderRight: '1px solid #ddd',
                      textAlign: 'center',
                      minWidth: '60px',
                    }}
                  >
                    S.No
                  </th>
                  {(invoiceCountDialog?.headers || []).map((header, i) => (
                    <th
                      key={i}
                      style={{
                        padding: '12px 20px',
                        whiteSpace: 'nowrap',
                        position: 'sticky',
                        top: 0,
                        zIndex: 2,
                        backgroundColor: '#f0f4f8',
                        borderBottom: '2px solid #ccc',
                        borderRight: '1px solid #ddd',
                        textAlign: 'center',
                        minWidth: '160px',
                      }}
                    >
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {invoiceCountDialog?.loading ? (
                  <tr>
                    <td
                      colSpan={(invoiceCountDialog?.headers?.length || 0) + 1}
                      style={{ textAlign: 'center', color: 'blue', padding: '30px' }}
                    >
                      Loading...
                    </td>
                  </tr>
                ) : (invoiceCountDialog?.data || []).length > 0 ? (
                  (invoiceCountDialog?.data || []).map((item, index) => (
                    <tr
                      key={index}
                      style={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f9fafb' }}
                    >
                      <td
                        style={{
                          padding: '10px 20px',
                          whiteSpace: 'nowrap',
                          borderBottom: '1px solid #eee',
                          borderRight: '1px solid #eee',
                          textAlign: 'center',
                        }}
                      >
                        {index + 1}
                      </td>
                      {(invoiceCountDialog?.headers || []).map((header, i) => (
                        <td
                          key={i}
                          style={{
                            padding: '10px 20px',
                            whiteSpace: 'nowrap',
                            borderBottom: '1px solid #eee',
                            borderRight: '1px solid #eee',
                            textAlign: 'center',
                            minWidth: '160px',
                          }}
                        >
                          {item[header] ?? "-"}
                        </td>
                      ))}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={(invoiceCountDialog?.headers?.length || 0) + 1}
                      style={{ textAlign: 'center', color: 'red', padding: '30px' }}
                    >
                      No Data Found!!
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInvoiceCountDialog({ open: false, data: [], headers: [], loading: false })}>Close</Button>
        </DialogActions>
      </Dialog>

      <Modal open={openOTPModal}>
        <Box sx={style}>
          <ValidatorForm
            ref={form}
            onSubmit={vyanaAuthHandler}
            onError={(errors) => console.log("ValidatorForm errors:", errors)}
          >
            <Inputfield
              textLabel="OTP"
              inputType="text"
              name="OTP"
              value={auth_otp}
              textOnchangeFunction={(e) => setAuthOTP(e.target.value)}
              requiredField="*"
              validator={["required"]}
              errorMsg={["This field is required"]}
            />
            <div className="mt-20">
              <button className="button-primary" type="submit">
                Submit
              </button>
              <button
                className="button-outlined-secondary"
                type="button"
                onClick={closeOptModalHandler}
              >
                Close
              </button>
            </div>
          </ValidatorForm>
        </Box>
      </Modal>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </React.Fragment>
  );
}